/* Table of Contents
==================================================

    #Slate Default
    #Custom Velstar

==================================================
*/

/* ==========================================================================
#Slate Default
========================================================================== */

window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Settings ================*/
//Create Vars that match SCSS breakpoints, defined in variables.scss.liquid file.
var screenSM = 576,
    screenMD = 768,
    screenLG = 992,
    screenXL = 1200;
    
var slickPrevArrow = "<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg aria-hidden='true' data-prefix='fal' data-icon='chevron-left' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 512'><path d='M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z'></path></svg></button>",
    slickNextArrow = "<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg aria-hidden='true' data-prefix='fal' data-icon='chevron-right' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 512'><path d='M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z'></path></svg></button>";

//if no image available, load the SVG placeholder image. Generate by the liquid tag {{ 'product-1' | placeholder_svg_tag: 'svg-placeholder' }}
var svgPlaceholder = '<svg class="svg-placeholder" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M375.5 345.2c0-.1 0-.1 0 0 0-.1 0-.1 0 0-1.1-2.9-2.3-5.5-3.4-7.8-1.4-4.7-2.4-13.8-.5-19.8 3.4-10.6 3.6-40.6 1.2-54.5-2.3-14-12.3-29.8-18.5-36.9-5.3-6.2-12.8-14.9-15.4-17.9 8.6-5.6 13.3-13.3 14-23 0-.3 0-.6.1-.8.4-4.1-.6-9.9-3.9-13.5-2.1-2.3-4.8-3.5-8-3.5h-54.9c-.8-7.1-3-13-5.2-17.5-6.8-13.9-12.5-16.5-21.2-16.5h-.7c-8.7 0-14.4 2.5-21.2 16.5-2.2 4.5-4.4 10.4-5.2 17.5h-48.5c-3.2 0-5.9 1.2-8 3.5-3.2 3.6-4.3 9.3-3.9 13.5 0 .2 0 .5.1.8.7 9.8 5.4 17.4 14 23-2.6 3.1-10.1 11.7-15.4 17.9-6.1 7.2-16.1 22.9-18.5 36.9-2.2 13.3-1.2 47.4 1 54.9 1.1 3.8 1.4 14.5-.2 19.4-1.2 2.4-2.3 5-3.4 7.9-4.4 11.6-6.2 26.3-5 32.6 1.8 9.9 16.5 14.4 29.4 14.4h176.8c12.9 0 27.6-4.5 29.4-14.4 1.2-6.5-.5-21.1-5-32.7zm-97.7-178c.3-3.2.8-10.6-.2-18 2.4 4.3 5 10.5 5.9 18h-5.7zm-36.3-17.9c-1 7.4-.5 14.8-.2 18h-5.7c.9-7.5 3.5-13.7 5.9-18zm4.5-6.9c0-.1.1-.2.1-.4 4.4-5.3 8.4-5.8 13.1-5.8h.7c4.7 0 8.7.6 13.1 5.8 0 .1 0 .2.1.4 3.2 8.9 2.2 21.2 1.8 25h-30.7c-.4-3.8-1.3-16.1 1.8-25zm-70.7 42.5c0-.3 0-.6-.1-.9-.3-3.4.5-8.4 3.1-11.3 1-1.1 2.1-1.7 3.4-2.1l-.6.6c-2.8 3.1-3.7 8.1-3.3 11.6 0 .2 0 .5.1.8.3 3.5.9 11.7 10.6 18.8.3.2.8.2 1-.2.2-.3.2-.8-.2-1-9.2-6.7-9.8-14.4-10-17.7 0-.3 0-.6-.1-.8-.3-3.2.5-7.7 3-10.5.8-.8 1.7-1.5 2.6-1.9h155.7c1 .4 1.9 1.1 2.6 1.9 2.5 2.8 3.3 7.3 3 10.5 0 .2 0 .5-.1.8-.3 3.6-1 13.1-13.8 20.1-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .3-.1 13.5-7.5 14.3-17.5 14.6-21.3 0-.3 0-.5.1-.8.4-3.5-.5-8.5-3.3-11.6l-.6-.6c1.3.4 2.5 1.1 3.4 2.1 2.6 2.9 3.5 7.9 3.1 11.3 0 .3 0 .6-.1.9-1.5 20.9-23.6 31.4-65.5 31.4h-43.8c-41.8 0-63.9-10.5-65.4-31.4zm91 89.1h-7c0-1.5 0-3-.1-4.2-.2-12.5-2.2-31.1-2.7-35.1h3.6c.8 0 1.4-.6 1.4-1.4v-14.1h2.4v14.1c0 .8.6 1.4 1.4 1.4h3.7c-.4 3.9-2.4 22.6-2.7 35.1v4.2zm65.3 11.9h-16.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h16.8v2.8h-62.2c0-.9-.1-1.9-.1-2.8h33.9c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-33.9c-.1-3.2-.1-6.3-.1-9h62.5v9zm-12.5 24.4h-6.3l.2-1.6h5.9l.2 1.6zm-5.8-4.5l1.6-12.3h2l1.6 12.3h-5.2zm-57-19.9h-62.4v-9h62.5c0 2.7 0 5.8-.1 9zm-62.4 1.4h62.4c0 .9-.1 1.8-.1 2.8H194v-2.8zm65.2 0h7.3c0 .9.1 1.8.1 2.8H259c.1-.9.1-1.8.1-2.8zm7.2-1.4h-7.2c.1-3.2.1-6.3.1-9h7c0 2.7 0 5.8.1 9zm-7.7-66.7v6.8h-9v-6.8h9zm-8.9 8.3h9v.7h-9v-.7zm0 2.1h9v2.3h-9v-2.3zm26-1.4h-9v-.7h9v.7zm-9 3.7v-2.3h9v2.3h-9zm9-5.9h-9v-6.8h9v6.8zm-119.3 91.1c-2.1-7.1-3-40.9-.9-53.6 2.2-13.5 11.9-28.6 17.8-35.6 5.6-6.5 13.5-15.7 15.7-18.3 11.4 6.4 28.7 9.6 51.8 9.6h6v14.1c0 .8.6 1.4 1.4 1.4h5.4c.3 3.1 2.4 22.4 2.7 35.1 0 1.2.1 2.6.1 4.2h-63.9c-.8 0-1.4.6-1.4 1.4v16.1c0 .8.6 1.4 1.4 1.4H256c-.8 11.8-2.8 24.7-8 33.3-2.6 4.4-4.9 8.5-6.9 12.2-.4.7-.1 1.6.6 1.9.2.1.4.2.6.2.5 0 1-.3 1.3-.8 1.9-3.7 4.2-7.7 6.8-12.1 5.4-9.1 7.6-22.5 8.4-34.7h7.8c.7 11.2 2.6 23.5 7.1 32.4.2.5.8.8 1.3.8.2 0 .4 0 .6-.2.7-.4 1-1.2.6-1.9-4.3-8.5-6.1-20.3-6.8-31.1H312l-2.4 18.6c-.1.4.1.8.3 1.1.3.3.7.5 1.1.5h9.6c.4 0 .8-.2 1.1-.5.3-.3.4-.7.3-1.1l-2.4-18.6H333c.8 0 1.4-.6 1.4-1.4v-16.1c0-.8-.6-1.4-1.4-1.4h-63.9c0-1.5 0-2.9.1-4.2.2-12.7 2.3-32 2.7-35.1h5.2c.8 0 1.4-.6 1.4-1.4v-14.1h6.2c23.1 0 40.4-3.2 51.8-9.6 2.3 2.6 10.1 11.8 15.7 18.3 5.9 6.9 15.6 22.1 17.8 35.6 2.2 13.4 2 43.2-1.1 53.1-1.2 3.9-1.4 8.7-1 13-1.7-2.8-2.9-4.4-3-4.6-.2-.3-.6-.5-.9-.6h-.5c-.2 0-.4.1-.5.2-.6.5-.8 1.4-.3 2 0 0 .2.3.5.8 1.4 2.1 5.6 8.4 8.9 16.7h-42.9v-43.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v44.9c0 .1-.1.2-.1.3 0 .1 0 .2.1.3v9c-1.1 2-3.9 3.7-10.5 3.7h-7.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h7.5c5 0 8.5-.9 10.5-2.8-.1 3.1-1.5 6.5-10.5 6.5H210.4c-9 0-10.5-3.4-10.5-6.5 2 1.9 5.5 2.8 10.5 2.8h67.4c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-67.4c-6.7 0-9.4-1.7-10.5-3.7v-54.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v43.8h-43.6c4.2-10.2 9.4-17.4 9.5-17.5.5-.6.3-1.5-.3-2s-1.5-.3-2 .3c-.1.2-1.4 2-3.2 5 .1-4.9-.4-10.2-1.1-12.8zm221.4 60.2c-1.5 8.3-14.9 12-26.6 12H174.4c-11.8 0-25.1-3.8-26.6-12-1-5.7.6-19.3 4.6-30.2H197v9.8c0 6.4 4.5 9.7 13.4 9.7h105.4c8.9 0 13.4-3.3 13.4-9.7v-9.8h44c4 10.9 5.6 24.5 4.6 30.2z"></path><path d="M286.1 359.3c0 .4.3.7.7.7h14.7c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-14.7c-.3 0-.7.3-.7.7zm5.3-145.6c13.5-.5 24.7-2.3 33.5-5.3.4-.1.6-.5.4-.9-.1-.4-.5-.6-.9-.4-8.6 3-19.7 4.7-33 5.2-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm-11.3.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H242c-19.9 0-35.3-2.5-45.9-7.4-.4-.2-.8 0-.9.3-.2.4 0 .8.3.9 10.8 5 26.4 7.5 46.5 7.5h38.1zm-7.2 116.9c.4.1.9.1 1.4.1 1.7 0 3.4-.7 4.7-1.9 1.4-1.4 1.9-3.2 1.5-5-.2-.8-.9-1.2-1.7-1.1-.8.2-1.2.9-1.1 1.7.3 1.2-.4 2-.7 2.4-.9.9-2.2 1.3-3.4 1-.8-.2-1.5.3-1.7 1.1s.2 1.5 1 1.7z"></path><path d="M275.5 331.6c-.8 0-1.4.6-1.5 1.4 0 .8.6 1.4 1.4 1.5h.3c3.6 0 7-2.8 7.7-6.3.2-.8-.4-1.5-1.1-1.7-.8-.2-1.5.4-1.7 1.1-.4 2.3-2.8 4.2-5.1 4zm5.4 1.6c-.6.5-.6 1.4-.1 2 1.1 1.3 2.5 2.2 4.2 2.8.2.1.3.1.5.1.6 0 1.1-.3 1.3-.9.3-.7-.1-1.6-.8-1.8-1.2-.5-2.2-1.2-3-2.1-.6-.6-1.5-.6-2.1-.1zm-38.2 12.7c.5 0 .9 0 1.4-.1.8-.2 1.3-.9 1.1-1.7-.2-.8-.9-1.3-1.7-1.1-1.2.3-2.5-.1-3.4-1-.4-.4-1-1.2-.8-2.4.2-.8-.3-1.5-1.1-1.7-.8-.2-1.5.3-1.7 1.1-.4 1.8.1 3.7 1.5 5 1.2 1.2 2.9 1.9 4.7 1.9z"></path><path d="M241.2 349.6h.3c.8 0 1.4-.7 1.4-1.5s-.7-1.4-1.5-1.4c-2.3.1-4.6-1.7-5.1-4-.2-.8-.9-1.3-1.7-1.1-.8.2-1.3.9-1.1 1.7.7 3.5 4.1 6.3 7.7 6.3zm-9.7 3.6c.2 0 .3 0 .5-.1 1.6-.6 3-1.6 4.2-2.8.5-.6.5-1.5-.1-2s-1.5-.5-2 .1c-.8.9-1.8 1.6-3 2.1-.7.3-1.1 1.1-.8 1.8 0 .6.6.9 1.2.9z"></path></svg>';
//if no image available, load the SVG placeholder image. Generate by the liquid tag {{ 'product-1' | placeholder_svg_tag: 'svg-placeholder' }}
var svgPlaceholder = '<svg class="svg-placeholder" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M375.5 345.2c0-.1 0-.1 0 0 0-.1 0-.1 0 0-1.1-2.9-2.3-5.5-3.4-7.8-1.4-4.7-2.4-13.8-.5-19.8 3.4-10.6 3.6-40.6 1.2-54.5-2.3-14-12.3-29.8-18.5-36.9-5.3-6.2-12.8-14.9-15.4-17.9 8.6-5.6 13.3-13.3 14-23 0-.3 0-.6.1-.8.4-4.1-.6-9.9-3.9-13.5-2.1-2.3-4.8-3.5-8-3.5h-54.9c-.8-7.1-3-13-5.2-17.5-6.8-13.9-12.5-16.5-21.2-16.5h-.7c-8.7 0-14.4 2.5-21.2 16.5-2.2 4.5-4.4 10.4-5.2 17.5h-48.5c-3.2 0-5.9 1.2-8 3.5-3.2 3.6-4.3 9.3-3.9 13.5 0 .2 0 .5.1.8.7 9.8 5.4 17.4 14 23-2.6 3.1-10.1 11.7-15.4 17.9-6.1 7.2-16.1 22.9-18.5 36.9-2.2 13.3-1.2 47.4 1 54.9 1.1 3.8 1.4 14.5-.2 19.4-1.2 2.4-2.3 5-3.4 7.9-4.4 11.6-6.2 26.3-5 32.6 1.8 9.9 16.5 14.4 29.4 14.4h176.8c12.9 0 27.6-4.5 29.4-14.4 1.2-6.5-.5-21.1-5-32.7zm-97.7-178c.3-3.2.8-10.6-.2-18 2.4 4.3 5 10.5 5.9 18h-5.7zm-36.3-17.9c-1 7.4-.5 14.8-.2 18h-5.7c.9-7.5 3.5-13.7 5.9-18zm4.5-6.9c0-.1.1-.2.1-.4 4.4-5.3 8.4-5.8 13.1-5.8h.7c4.7 0 8.7.6 13.1 5.8 0 .1 0 .2.1.4 3.2 8.9 2.2 21.2 1.8 25h-30.7c-.4-3.8-1.3-16.1 1.8-25zm-70.7 42.5c0-.3 0-.6-.1-.9-.3-3.4.5-8.4 3.1-11.3 1-1.1 2.1-1.7 3.4-2.1l-.6.6c-2.8 3.1-3.7 8.1-3.3 11.6 0 .2 0 .5.1.8.3 3.5.9 11.7 10.6 18.8.3.2.8.2 1-.2.2-.3.2-.8-.2-1-9.2-6.7-9.8-14.4-10-17.7 0-.3 0-.6-.1-.8-.3-3.2.5-7.7 3-10.5.8-.8 1.7-1.5 2.6-1.9h155.7c1 .4 1.9 1.1 2.6 1.9 2.5 2.8 3.3 7.3 3 10.5 0 .2 0 .5-.1.8-.3 3.6-1 13.1-13.8 20.1-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .3-.1 13.5-7.5 14.3-17.5 14.6-21.3 0-.3 0-.5.1-.8.4-3.5-.5-8.5-3.3-11.6l-.6-.6c1.3.4 2.5 1.1 3.4 2.1 2.6 2.9 3.5 7.9 3.1 11.3 0 .3 0 .6-.1.9-1.5 20.9-23.6 31.4-65.5 31.4h-43.8c-41.8 0-63.9-10.5-65.4-31.4zm91 89.1h-7c0-1.5 0-3-.1-4.2-.2-12.5-2.2-31.1-2.7-35.1h3.6c.8 0 1.4-.6 1.4-1.4v-14.1h2.4v14.1c0 .8.6 1.4 1.4 1.4h3.7c-.4 3.9-2.4 22.6-2.7 35.1v4.2zm65.3 11.9h-16.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h16.8v2.8h-62.2c0-.9-.1-1.9-.1-2.8h33.9c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-33.9c-.1-3.2-.1-6.3-.1-9h62.5v9zm-12.5 24.4h-6.3l.2-1.6h5.9l.2 1.6zm-5.8-4.5l1.6-12.3h2l1.6 12.3h-5.2zm-57-19.9h-62.4v-9h62.5c0 2.7 0 5.8-.1 9zm-62.4 1.4h62.4c0 .9-.1 1.8-.1 2.8H194v-2.8zm65.2 0h7.3c0 .9.1 1.8.1 2.8H259c.1-.9.1-1.8.1-2.8zm7.2-1.4h-7.2c.1-3.2.1-6.3.1-9h7c0 2.7 0 5.8.1 9zm-7.7-66.7v6.8h-9v-6.8h9zm-8.9 8.3h9v.7h-9v-.7zm0 2.1h9v2.3h-9v-2.3zm26-1.4h-9v-.7h9v.7zm-9 3.7v-2.3h9v2.3h-9zm9-5.9h-9v-6.8h9v6.8zm-119.3 91.1c-2.1-7.1-3-40.9-.9-53.6 2.2-13.5 11.9-28.6 17.8-35.6 5.6-6.5 13.5-15.7 15.7-18.3 11.4 6.4 28.7 9.6 51.8 9.6h6v14.1c0 .8.6 1.4 1.4 1.4h5.4c.3 3.1 2.4 22.4 2.7 35.1 0 1.2.1 2.6.1 4.2h-63.9c-.8 0-1.4.6-1.4 1.4v16.1c0 .8.6 1.4 1.4 1.4H256c-.8 11.8-2.8 24.7-8 33.3-2.6 4.4-4.9 8.5-6.9 12.2-.4.7-.1 1.6.6 1.9.2.1.4.2.6.2.5 0 1-.3 1.3-.8 1.9-3.7 4.2-7.7 6.8-12.1 5.4-9.1 7.6-22.5 8.4-34.7h7.8c.7 11.2 2.6 23.5 7.1 32.4.2.5.8.8 1.3.8.2 0 .4 0 .6-.2.7-.4 1-1.2.6-1.9-4.3-8.5-6.1-20.3-6.8-31.1H312l-2.4 18.6c-.1.4.1.8.3 1.1.3.3.7.5 1.1.5h9.6c.4 0 .8-.2 1.1-.5.3-.3.4-.7.3-1.1l-2.4-18.6H333c.8 0 1.4-.6 1.4-1.4v-16.1c0-.8-.6-1.4-1.4-1.4h-63.9c0-1.5 0-2.9.1-4.2.2-12.7 2.3-32 2.7-35.1h5.2c.8 0 1.4-.6 1.4-1.4v-14.1h6.2c23.1 0 40.4-3.2 51.8-9.6 2.3 2.6 10.1 11.8 15.7 18.3 5.9 6.9 15.6 22.1 17.8 35.6 2.2 13.4 2 43.2-1.1 53.1-1.2 3.9-1.4 8.7-1 13-1.7-2.8-2.9-4.4-3-4.6-.2-.3-.6-.5-.9-.6h-.5c-.2 0-.4.1-.5.2-.6.5-.8 1.4-.3 2 0 0 .2.3.5.8 1.4 2.1 5.6 8.4 8.9 16.7h-42.9v-43.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v44.9c0 .1-.1.2-.1.3 0 .1 0 .2.1.3v9c-1.1 2-3.9 3.7-10.5 3.7h-7.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h7.5c5 0 8.5-.9 10.5-2.8-.1 3.1-1.5 6.5-10.5 6.5H210.4c-9 0-10.5-3.4-10.5-6.5 2 1.9 5.5 2.8 10.5 2.8h67.4c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-67.4c-6.7 0-9.4-1.7-10.5-3.7v-54.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v43.8h-43.6c4.2-10.2 9.4-17.4 9.5-17.5.5-.6.3-1.5-.3-2s-1.5-.3-2 .3c-.1.2-1.4 2-3.2 5 .1-4.9-.4-10.2-1.1-12.8zm221.4 60.2c-1.5 8.3-14.9 12-26.6 12H174.4c-11.8 0-25.1-3.8-26.6-12-1-5.7.6-19.3 4.6-30.2H197v9.8c0 6.4 4.5 9.7 13.4 9.7h105.4c8.9 0 13.4-3.3 13.4-9.7v-9.8h44c4 10.9 5.6 24.5 4.6 30.2z"></path><path d="M286.1 359.3c0 .4.3.7.7.7h14.7c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-14.7c-.3 0-.7.3-.7.7zm5.3-145.6c13.5-.5 24.7-2.3 33.5-5.3.4-.1.6-.5.4-.9-.1-.4-.5-.6-.9-.4-8.6 3-19.7 4.7-33 5.2-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm-11.3.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H242c-19.9 0-35.3-2.5-45.9-7.4-.4-.2-.8 0-.9.3-.2.4 0 .8.3.9 10.8 5 26.4 7.5 46.5 7.5h38.1zm-7.2 116.9c.4.1.9.1 1.4.1 1.7 0 3.4-.7 4.7-1.9 1.4-1.4 1.9-3.2 1.5-5-.2-.8-.9-1.2-1.7-1.1-.8.2-1.2.9-1.1 1.7.3 1.2-.4 2-.7 2.4-.9.9-2.2 1.3-3.4 1-.8-.2-1.5.3-1.7 1.1s.2 1.5 1 1.7z"></path><path d="M275.5 331.6c-.8 0-1.4.6-1.5 1.4 0 .8.6 1.4 1.4 1.5h.3c3.6 0 7-2.8 7.7-6.3.2-.8-.4-1.5-1.1-1.7-.8-.2-1.5.4-1.7 1.1-.4 2.3-2.8 4.2-5.1 4zm5.4 1.6c-.6.5-.6 1.4-.1 2 1.1 1.3 2.5 2.2 4.2 2.8.2.1.3.1.5.1.6 0 1.1-.3 1.3-.9.3-.7-.1-1.6-.8-1.8-1.2-.5-2.2-1.2-3-2.1-.6-.6-1.5-.6-2.1-.1zm-38.2 12.7c.5 0 .9 0 1.4-.1.8-.2 1.3-.9 1.1-1.7-.2-.8-.9-1.3-1.7-1.1-1.2.3-2.5-.1-3.4-1-.4-.4-1-1.2-.8-2.4.2-.8-.3-1.5-1.1-1.7-.8-.2-1.5.3-1.7 1.1-.4 1.8.1 3.7 1.5 5 1.2 1.2 2.9 1.9 4.7 1.9z"></path><path d="M241.2 349.6h.3c.8 0 1.4-.7 1.4-1.5s-.7-1.4-1.5-1.4c-2.3.1-4.6-1.7-5.1-4-.2-.8-.9-1.3-1.7-1.1-.8.2-1.3.9-1.1 1.7.7 3.5 4.1 6.3 7.7 6.3zm-9.7 3.6c.2 0 .3 0 .5-.1 1.6-.6 3-1.6 4.2-2.8.5-.6.5-1.5-.1-2s-1.5-.5-2 .1c-.8.9-1.8 1.6-3 2.1-.7.3-1.1 1.1-.8 1.8 0 .6.6.9 1.2.9z"></path></svg>';
//BG: The below function is used by both the Recently Viewed and Related Products. When looping through the products, we use the below as a template.
function outputProduct(data, outputLocation) {
    var imageRatioClass = $(outputLocation).attr('data-image-ratio');
    var tagArray = data.tags;
    var colourGroupTag = '';
    tagArray.forEach(function (item, index) {
        if ((item.toUpperCase() === "NEW_IN")) {
            colourGroupTag = '<div class="tag-top new-in"><p>New In</p></div>';
        } else if ((item.toUpperCase() === "EXCLUSIVE")) {
            colourGroupTag = '<div class="tag-top exclusive"><p>Exclusive</p></div>';
        } else if ((item.toUpperCase() === "SALE")) {
            colourGroupTag = '<div class="tag-top sale"><p>Sale</p></div>';
       }
    });
    var variantSKU = '';
    if(data['variants'][0].sku != '') {
        variantSKU += '<span class="product-sku">' + data['variants'][0].sku + '</span>';
    } else {
        variantSKU += '';
    }

    var variantStock = data.available;
    var variantStockHTML = '';
    if(variantStock == true) {
        variantStockHTML += '<div class="in-stock"><span class="icon"></span>In Stock</div>';
    } else {
        variantStockHTML += '';
    }

    var classList = '';
    var buttonText = '';
    if(variantStock == true) {
        classList += 'variant-available';
        buttonText += 'Add to basket';
    } else {
        classList += 'variant-not-available btn-sold-out';
        buttonText += 'Notify me';
    }


    var firstVariant = data['variants'][0];
    var firstVariantId = data['variants'][0].id;

    var itemProductForm = '';
  
    if(variantStock == true) {
      itemProductForm += '<form method="post" action="/cart/add" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data"><input type="hidden" name="form_type" value="product" tabindex="0"><input type="hidden" name="utf8" value="✓" tabindex="0">';
      itemProductForm += '<select name="id" class="no-js no-js-option-select" data-product-select="" tabindex="0"><option selected="selected" value="' + firstVariantId + '">' + firstVariant.option1 + '</option></select>';
      itemProductForm += '<div class="product-quantity-container"><input type="number" class="product-quantity" name="quantity" value="1" min="1" tabindex="0"></div>';
      itemProductForm += '<div class="product-add-to-basket margin-right-zero"><button type="submit" name="add" data-add-to-cart="" class="btn btn-primary btn-margin-bottom ' + classList + '" tabindex="0"><span data-add-to-cart-text="">' + buttonText + '</span></button></div>';
      itemProductForm += '<span class="product-quickview"> <span class="btn btn-secondary-light btn-margin-bottom" data-product-availability="true" data-product-url="/products/'+data.handle+'">Quick view</span></span>';

      itemProductForm += '</form>';
    } else {
      itemProductForm += '<form method="post" action="/cart/add" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data"><input type="hidden" name="form_type" value="product" tabindex="0"><input type="hidden" name="utf8" value="✓" tabindex="0">';
      itemProductForm += '<select name="id" class="no-js no-js-option-select" data-product-select="" tabindex="0"><option selected="selected" value="' + firstVariantId + '">' + firstVariant.option1 + '</option></select>';
      itemProductForm += '<div class="product-quantity-container"><input type="number" class="product-quantity" name="quantity" value="1" min="1" tabindex="0"></div>';
      itemProductForm += '<a href="/products/'+data.handle+'" name="add" class="btn btn-primary btn-margin-bottom variant-available btn-add-to-cart notify-me" tabindex="0"><span data-add-to-cart-text="">' + buttonText + '</span></a>';
      itemProductForm += '<span class="product-quickview"> <span class="btn btn-secondary-light btn-margin-bottom" data-product-availability="true" data-product-url="/products/'+data.handle+'">Quick view</span></span>';

      itemProductForm += '</form>';
    }
    

    var productHTML = "";
        productHTML += '<div class="col-6 col-md-2 col-lg-3 col-new featured-product">';
            productHTML += '<div class="top-height">';
            productHTML += colourGroupTag;
            productHTML += '</div>';
            productHTML += '<div class="product-image">';
                productHTML += '<a href="/products/'+data.handle+'" title="'+data.title+'" class="'+imageRatioClass+'">';
                    if (data.featured_image != null) {
                        productHTML += '<img data-sizes="auto" data-src="'+slate.Image.getSizedImageUrl(data.featured_image,'400x')+'" data-srcset="'+slate.Image.getSizedImageUrl(data.featured_image,'400x')+' 400w, '+slate.Image.getSizedImageUrl(data.featured_image,'540x')+' 540w, '+slate.Image.getSizedImageUrl(data.featured_image,'720x')+' 720w, '+slate.Image.getSizedImageUrl(data.featured_image,'900x')+' 900w" alt="'+data.title+'" class="img-fluid lazyload" />';
                    } else {
                        productHTML += svgPlaceholder;
                    }
                productHTML += '</a>';
                productHTML += '<span class="smartwishlist" data-product="'+ data.id +'" data-variant="'+ data['variants'][0].id +'"></span>';
            productHTML += '</div>';
            productHTML += '<div class="product-details">';
                    productHTML += '<h3 class="product-title">'+data.title+'</h3>';
                    productHTML += '<span class="product-price"><span class="money coll wsaio-pid-'+data.id+'" product_id="'+data.id+'" product_handle="'+data.handle+'" product_variant_id="'+data['variants'][0].id+'" product_variant_sku="'+data['variants'][0].sku+'" product_variant_price="'+data['variants'][0].price+'" product_variant_compare_price="'+data['variants'][0].compare_at_price+'">'+slate.Currency.formatMoney(data.price, theme.moneyFormat)+'</span></span>';
                    productHTML += itemProductForm;
                    productHTML += '<div class="product-compare add-to-compare" data-product-handle="'+ data.handle +'" data-product-type="all"><div class="no-compare"><span>Add to compare</span></div><div class="in-compare"><span>Added to compare</span></div></div>';
            productHTML += '</div>';
        productHTML += '</div>';
  
    $(outputLocation).find('.row.featured-products-slick').append(productHTML);


    quickView();

    $(config.addToCartFormSelectorNew).submit(function (e) {
        e.preventDefault();
        addToCart($(this));
    });
}

/*
BG: persistentCheck: The idea being to constantly check (or persistently check) if the target exists, if it does, pass in an additional function that will trigger once condition is true. If condition is never true, have a timeoutTime to stop checking. 
*/
function persistentCheck(target,targetValue,paramFunction,paramTarget,timeoutTime) {
    //console.log('persistentCheckFunction');
    var checkExist = setInterval(function() {
        //console.log('Persistently checking for: '+target);
    //keep checking to see if condition is true 

    if ($(target).length > targetValue) {
            //console.log('condition is true, will no longer check.');
            //check paramFunction is actually a function
            if (typeof paramFunction == "function") {
                paramFunction(paramTarget); 
            }
            //clear interval
            clearInterval(checkExist);
        }
    }, 100); // check every 100ms
    
    setTimeout(function(){
        //console.log('couldn\'t find target or condition wasn\'t true');
        clearInterval(checkExist);
    }, timeoutTime);
}

// Build additional elements


/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      window.selected_variant_id = variant.id;
//       console.log('variant',variant.id)
//       if(typeof WSAIO !== "undefined" && typeof WSAIO.productDiscount === "function"){
        
        
//         var newhandle=window.location.href.split("products/")[1].split("?")[0]
//         $.getJSON("/products/"+newhandle+".js",function(e){
//           window.current_product=e;
       
//         WSAIO.variantChange(variant,'wsaio-pid-'+current_product.id, current_product);
//         WSAIO.variantChange(variant,'wsaio-pid-'+current_product.id, current_product);
//         WSAIO.productDiscount({
//           template: 'product',
//           product_id: current_product.id,
//           product_handle: current_product.handle,
//           variant_id: variant.id,
//           variant_sku: variant.sku,
//           variant_price: variant.price,
//           variant_compare_at_price: variant.compare_at_price
//         });
//            })
//         setTimeout(function(){
//           WSAIO.qtyController({
//             addToCart_selector: '.btn-add-to-cart',
//             functionality: 'variant_level',
//             removeableSelector_qty: '.product-quantity-select',
//             removeableSelector_variants:'.swatch-element'
//           });
//         },1000);
//       }
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Templates ================*/
/*================ Templates ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productSku: '[data-product-sku]',
    productStock: '[data-product-stock]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));

    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */

    updateAddToCartState: function(evt) {
        var attr = $('.product-add-to-basket').attr('data-call-to-order');

        var variant = evt.variant;
        var variantStock = $('div#variant-inventory-levels input.variant-inventory-level.'+variant.id).val();
        if (variant) {
            $(selectors.priceWrapper, this.$container).removeClass('hide');

        } else {
            $(selectors.addToCart, this.$container).prop('disabled', true);
            $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
            $(selectors.priceWrapper, this.$container).addClass('hide');
            return;

        }

        if (variant.available) {
            if (typeof attr !== 'undefined' && attr !== false) {
                $(selectors.addToCart, this.$container).attr('id','call_to_order');
                $(selectors.addToCartText, this.$container).html('Call to order');
                $(selectors.addToCart, this.$container).removeClass('variant-available');
                $(selectors.productStock, this.$container).html('0');
            } else {
                //$(selectors.addToCart, this.$container).prop('disabled', false);
                $(selectors.addToCart, this.$container).addClass('variant-available');
                $(selectors.addToCart, this.$container).removeClass('variant-not-available');
                $(selectors.addToCart, this.$container).attr('id','');
                $(selectors.addToCartText, this.$container).html('Add to basket');

                $(selectors.productStock, this.$container).html(variantStock);
                        $('.variant-sku').text(variant.sku);
            }
        } else {

            //$(selectors.addToCart, this.$container).prop('disabled', true);
            $('.variant-sku').text(variant.sku);

            $('.stock').html(variant.inventory_quantity );
            $(selectors.addToCart, this.$container).addClass('variant-not-available');
            $(selectors.addToCart, this.$container).removeClass('variant-available');

            if (typeof attr !== 'undefined' && attr !== false) {
                $(selectors.addToCart, this.$container).attr('id','call_to_order');
                $(selectors.addToCartText, this.$container).html('Call to order');
            } else {
                $(selectors.addToCart, this.$container).attr('id','BIS_trigger');
                $(selectors.addToCartText, this.$container).html('Email when available');
            }

            // $(selectors.addToCart, this.$container).attr('id','BIS_trigger');
            // $(selectors.addToCartText, this.$container).html('Email when available');

            $(selectors.productStock, this.$container).html('0');

        }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    updateProductSku: function(evt) {
   
      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.sku));

    },

    updateProductStock: function(evt) {
   
      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(current_variant.inventory_quantity));

    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
    });

//BG: Init slickSlider for Related Products.
function relatedSlickSlider(target) {
  var categoryPrevArrow = "<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg width='50px' height='100px' viewBox='0 0 50 100' version='1.1'><g id='carousel_indicator_left' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><g id='Group'><path d='M50,100 C50,100 50,0 50,0 C22.3857625,0 0,22.3857625 0,50 C0,77.6142375 22.3857625,100 50,100 Z' id='Oval' fill='#C8A07D' transform='translate(25.000000, 50.000000) scale(-1, 1) translate(-25.000000, -50.000000) '></path><polyline id='Path-3' stroke='#FFFFFF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' transform='translate(16.666667, 50.000000) scale(-1, 1) rotate(-90.000000) translate(-16.666667, -50.000000) ' points='8.33333333 45.8333333 16.6666667 54.1666667 25 45.8333333'></polyline></g></g></svg></button>",
  categoryNextArrow = "<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg width='50px' height='100px' viewBox='0 0 50 100' version='1.1'><g id='carousel_indicator_right' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><g id='Carousel-left' transform='translate(25.000000, 50.000000) scale(-1, 1) translate(-25.000000, -50.000000) '><path d='M50,100 C50,100 50,0 50,0 C22.3857625,0 0,22.3857625 0,50 C0,77.6142375 22.3857625,100 50,100 Z' id='Oval' fill='#C8A07D' transform='translate(25.000000, 50.000000) scale(-1, 1) translate(-25.000000, -50.000000) '></path><polyline id='Path-3' stroke='#FFFFFF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' transform='translate(16.666667, 50.000000) scale(-1, 1) rotate(-90.000000) translate(-16.666667, -50.000000) ' points='8.33333333 45.8333333 16.6666667 54.1666667 25 45.8333333'></polyline></g></g></svg></button>";

    $(target).slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 2,
        arrows:true,
        dots: false,
        prevArrow: categoryPrevArrow,
        nextArrow: categoryNextArrow,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
            },
            {
                breakpoint: 768,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
            },
            {
                breakpoint: 480,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots:true
            }
            }
        ]
    });
}


//BG: Make the call to the related products API
function relatedProductsAPI() {
  var productID = $('.featured-products.related-products').attr('data-product-id');
  
      if (productID) {
  
      //Make the JSON request to the recommendations API, pass over the current product ID.
      $.getJSON('/recommendations/products.json?product_id='+productID+'&limit=8', function(data) {
          //for each product in the API Response, pass over to the output function.
          $.each(data.products,function(i, product) {
              //BG: outputProduct function used in settings/common.js. It's basic styling.
              outputProduct(product,'.featured-products.related-products');
              var increment = i + 1;
  
              //BG: if we've cycled through all products, trigger the slickInit
              if (data.products.length == increment) {
                  //persistentCheck function in setting/common.js
                  persistentCheck('.featured-products.related-products .featured-product',4,relatedSlickSlider,'.featured-products.related-products .featured-products-slick',5000);
                  addProductCompare();
                }
          });
      });
  
      }
  }
    



function productSelectQuantity() {

  var product = $('.product__quantity__container');
  
  var quantitySelect = product.find('.product-quantity'),
    plusQuantity = product.find('[data-quantity="plus"]'),
    quantityInput = product.find('input[name="quantity"]'),
    maxQuantity = quantitySelect.attr('data-max-quantity'),
    minusQuantity = product.find('[data-quantity="minus"]');
  
    $(plusQuantity).click(function(e){
      // Stop acting like a button
      e.preventDefault();
      // Get the field name
      fieldName = product.attr('data-field');
      // Get its current value
      var currentVal = parseInt($(quantityInput).val());
      // If is not undefined
      if (!isNaN(currentVal)) {
        // Increment
        
        //MJ: Only increases quantity if there is the available stock
    
          $(quantityInput).val(currentVal + 1);
          var inputAmount = $(quantityInput).val();
          $(".product-quantity_new .product-quantity").attr('value', inputAmount);
        
      } 
    });
    // This button will decrement the value till 0
    $(minusQuantity).click(function(e) {
//       console.log("QQQ");
      // Stop acting like a button
      e.preventDefault();
      // Get the field name
      fieldName = product.attr('data-field');
      // Get its current value
      var currentVal = parseInt($(quantityInput).val());
      // If it isn't undefined or its greater than 0
      if (!isNaN(currentVal) && currentVal > 1) {
        // Decrement one
        $(quantityInput).val(currentVal - 1);
        var inputAmount = $(quantityInput).val();
        $(".product-quantity").attr('value', inputAmount);
        
      } else {
        $(quantityInput).val(0);
        var inputAmount = $(quantityInput).val();
      }
    });
  }
//Get URL Parameter
function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};


//BG: if variant parameter is available in the URL, change the selection based on this.
function changeProductByVariantID() {
    var variantID = getUrlParameter('variant');
    //console.log(variant);

    if (variantID) {
        $('.swatch [data-variant-id="'+variantID+'"]').find('input[type="radio"]').prop("checked", true);
 
   }
}

//BG: Intended to work with the 'back in stock' app. Trigger via button
// function notifyApp() {
//   var soldOutBtn = $('.btn-add-to-cart.variant-not-available'),
//       notifyBtn = $('.BIS_trigger');

//       soldOutBtn.click(function(e){
//         e.preventDefault();  
//         notifyBtn.click();
//       });
// }


// //BG: Intended to work with the 'back in stock' app. Trigger via soldout size label
// function notifyAppTwo() {
//   var soldOutLabel = $('.soldout > label'),
//       notifyBtn = $('.BIS_trigger');

//       soldOutLabel.click(function(e){
//       });
// }

function productTabs() {
  var tabs = $('.tabs-container .tab-header-container .tab'),
      inlineTabs = $('.tabs-container .tab-content-container .tab-title'),
      tabsContent = $('.tabs-container .tab-content-container .tab-content');
      activetab = $('.active');

      tabs.on('click', function(){
          tabs.removeClass('active');
          $(this).addClass('active');

          var tabName = $(this).attr('data-tab');

          inlineTabs.removeClass('active');
          $('.tabs-container .tab-content-container .tab-title[data-tab="'+tabName+'"]').addClass('active');

          tabsContent.removeClass('active');
          $('.tabs-container .tab-content-container .tab-content[data-tab="'+tabName+'"]').addClass('active');
      });

      inlineTabs.on('click', function(){
          var tabName = $(this).attr('data-tab');

          if ($(this).hasClass('active')) {
              $(this).removeClass('active');
              $('.tabs-container .tab-content-container .tab-content[data-tab="'+tabName+'"]').removeClass('active');
          } else {
              inlineTabs.removeClass('active');
              $(this).addClass('active');

              tabs.removeClass('active');
              $('.tabs-container .tab-header-container .tab[data-tab="'+tabName+'"]').addClass('active');

              tabsContent.removeClass('active');
              $('.tabs-container .tab-content-container .tab-content[data-tab="'+tabName+'"]').addClass('active');
          }
      });
      
}



function productSlick() {
    $('.product-detail-images').slick({
        slidesToShow: 1,
         slidesToScroll: 1,
       infinite: false,
       arrows: false,
       asNavFor: '.product-detail-thumbnails',
       responsive: [
           {
               breakpoint: 992,
               settings: {
                   slidesToShow: 1,
                   slidesToScroll: 1,
               }
           }
       ]
   });
   
   $('.product-detail-thumbnails').slick({
        slidesToShow: 4,
       slidesToScroll: 1,
       infinite: false,
       vertical: true,
        prevArrow: slickPrevArrow,
       nextArrow: slickNextArrow,
       asNavFor: '.product-detail-images',
       focusOnSelect: true,
       responsive: [
           {
               breakpoint: 992,
               settings: {
                   slidesToShow: 3
               }
           }
       ]
   });
}

function cartQuantitySelect() {
    var cartQuantity = $('.product-quantity');

    cartQuantity.each(function(){
        var quantitySelect = $(this).find('.product-quantity-select'),
            quantityValue = $(this).find('.product-quantity-value').attr('value'),
            quantityInput = $(this).find('.product-quantity-value');

        // LM Once quantity has been changed, need to update input value beneath so checkout quanity is updated as well.
        quantitySelect.on('change', function(){
            var selectedValue = $(this).find(':selected').attr('value');
            var selectedInput = $(this).next();

            $(selectedInput).attr('value', selectedValue);
        });
    });
}


    
//BG: Only run on Product Page.
if ($('body.template-product').length) {
    productSelectQuantity();
    relatedProductsAPI();
    productSlick();
    cartQuantitySelect();
    productTabs();    
    //BG: App related functions for Product Page
    // persistentCheck('.BIS_trigger',0,notifyApp,'nothing',1000000);
    // persistentCheck('.BIS_trigger',0,notifyAppTwo,'nothing',1000000);

  }

  return Product;
})();

/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
      
    if ($(this).hasClass('address-new-primary')) {
        $(this).addClass('hide');
    }
      
    if ($(this).hasClass('address-new-secondary')) {
        $('.address-new-primary').removeClass('hide');
    }
      
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
      
    if ($(this).hasClass('address-edit-primary')) {
        $(this).addClass('hide');
    }
      
    if ($(this).hasClass('address-edit-secondary')) {
        $('.address-edit-primary').removeClass('hide');
    }
  });

  // $('.address-delete').on('click', function() {
  //   var $el = $(this);
  //   var formId = $el.data('form-id');
  //   var confirmMessage = $el.data('confirm-message');
  //   if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
  //     Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
  //   }
  // });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

//Get URL Parameters 
function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

//create Cookie
function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

//Get cookie value
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

//Delete cookie
function eraseCookie(name) {
    document.cookie = name+'=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
}


function collectionReadMore() {
    var readmoreBtn = $('.collection-read-more'),
        collectionDescription = $('.collection-description .rte'),
        collectionDescriptionHeight = collectionDescription.height();
        //collectionNav = $('.collection-header .collection-sub-nav'),
        //collectionNavHeight = collectionNav.height();

        readmoreBtn.off('click').on('click', function(e){

        if (readmoreBtn.hasClass('active')) {

            // collectionNav.animate({
            //     height: collectionNavHeight
            // }, 1000);

            collectionDescription.removeClass('active');

            collectionDescription.animate({
                height: collectionDescriptionHeight
            }, 1000, function(){
                readmoreBtn.removeClass('active');
            });

            readmoreBtn.text('Read more');

        } else {

            // collectionNav.animate({
            //     height: collectionNav.get(0).scrollHeight
            // }, 1000, function(){
            //     $(this).height('auto');
            // });

            collectionDescription.addClass('active');

            collectionDescription.animate({
                height: collectionDescription.get(0).scrollHeight
            }, 1000, function(){
                $(this).height('auto');
                readmoreBtn.addClass('active');
            });

            readmoreBtn.text('Read less');

        }

    });
}

function collectionViews() {
    var collectionViewSelect = $('.collection-view li'),
        collectionView = $('#bc-sf-filter-products');

    if (getCookie('collectionView')) {
        collectionView.attr('class','row collection-view-six');
        collectionViewSelect.removeClass('active');
        $('.collection-view li.collection-view-six').addClass('active');
    }

    

    collectionViewSelect.click(function(){
        var collectionViewClass = $(this).attr('class').split(' ')[0];

        collectionViewSelect.removeClass('active');
        $(this).addClass('active');

        collectionView.attr('class','row '+collectionViewClass);

        if (collectionViewClass === 'collection-view-six' ) {
            setCookie('collectionView','six', 365)
        } else {
            eraseCookie('collectionView');
        }
    });



}

function filterToggle() {
    var filterTitle = $('.filter-title'),
        filterSidebar = $('.filter-sidebar');
    
    filterTitle.off('click').on('click', function(){
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            filterSidebar.slideUp();
        } else {
            $(this).addClass('active');
            filterSidebar.slideDown();
        }
    });
}


/*
 BG: On mobile, drop in a clickable button on the filters that closes the open filter state. 
 Used in conjunctioned with Product Filter and Search app
 */
function collectionFiltersMobileClose() {
    var filterTree = $('#bc-sf-filter-options-wrapper'),
        filterTitle = '<span class="mobile-filter-header"><h3>Filters</h3><span class="close"></span></span>',
        closeLength = $('#bc-sf-filter-tree .mobile-filter-header').length;
        
        if($('#bc-sf-filter-tree .mobile-filter-header').length < 1) {
            $(filterTitle).insertBefore(filterTree);
        }
}

/*
BG: On mobile, create click actions for filter and sort by buttons.
*/
function collectionFilterMobileActions() {
    var btnFilter = $('.filter-title'),
        filterTree = $('#bc-sf-filter-tree'),
        filterHeader = $('.mobile-filter-header .close');
        
    if ($(window).width() <= screenMD) {
        btnFilter.off().on('click', function(){
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                filterTree.removeClass('active');
                $('html').removeClass('no-scroll');
                $('body').removeClass('no-scroll');
            } else {
                filterTree.addClass('active');
                $(this).addClass('active');
                $('html').addClass('no-scroll');
                $('body').addClass('no-scroll');
            }
        });
    } else {
        btnFilter.off().on('click', function(){
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                filterTree.removeClass('active');
            } else {
                filterTree.addClass('active');
                $(this).addClass('active');
            }
        });
    }

    filterHeader.on('click', function(){
        btnFilter.removeClass('active');
        filterTree.removeClass('active');
        $('html').removeClass('no-scroll');
        $('body').removeClass('no-scroll');
    });
}

function collectionSortByMobile() {
    var BCSortBy = $('#bc-sf-filter-top-sorting option'),
    markupHTML = '<div class="sort-by-menu"><span class="mobile-filter-header"><h3>Sort by</h3><span class="close"></span></span><ul class="sort-by-list">',
    btnSortBy = $('#btn-sort');

    BCSortBy.each(function(){
        var optionValue = $(this).text(),
            optionData = $(this).attr('value');


        markupHTML += '<li data-value="'+optionData+'">'+optionValue+'</li>';

    });

    markupHTML += '</ul></div>';

    //if one exists already, remove it.
    $('.sort-by-menu').remove();
    $(markupHTML).insertAfter(btnSortBy);


    var overlay = $('.collection-overlay'),
    filterHeader = $('.mobile-filter-header .close');

    btnSortBy.on('click', function(){
        $('.sort-by-menu').addClass('active');
        overlay.addClass('active');
        $('html').addClass('no-scroll');
        $('body').addClass('no-scroll');
    });

    filterHeader.on('click', function(){
        overlay.removeClass('active');
        $('.sort-by-menu').removeClass('active');
        $('html').removeClass('no-scroll');
        $('body').removeClass('no-scroll');
    });


    $('.sort-by-list li').on('click', function(){
        var dataValue = $(this).attr('data-value');
        $('#bc-sf-filter-top-sorting-select option[value="'+dataValue+'"]').prop('selected', true).trigger('change');
    });
}

/**
 * BG: Update the product count from PF&S
 */
function productCount(value) {
    $('.collection-count .value').text(value);
}

function renameColours() {
    $('.bc-sf-filter-block-content li').each(function(){
        var value = $(this).find('.bc-sf-filter-option-value');

        $(value).text(function(i, text) {
            return text.replace(/_/g, ' ');
        });
    });

    $('.bc-sf-filter-option-label').each(function(){
        var selectedValue = $(this).find('strong');

        $(selectedValue).text(function(i, text) {
            return text.replace(/_/g, ' ');
        });
    });
}


//BG: For each product, find the related product colour and link to it.
function collectionProductColours() {
    var collectionProducts = $('.collection-listing .product-single');

    //Loop through the product list, and get the productID for each product. The loop through the second list of products, and match them based on the productGroup.
    collectionProducts.each(function(){
    var productID = $(this).attr('data-product-id'),
        productGroup = $('.collection-product-colours li[data-product-id="'+productID+'"]').attr('data-product-group'),
        productGroupCollection = $('.collection-product-colours li[data-product-group="'+productGroup+'"]');

        //Loop through the product grouping, and append the products to their related grouping.
        productGroupCollection.each(function(){
            var thisProductID = $(this).attr('data-product-id'),
                thisProductColour = $(this).attr('data-product-colour'),
                thisProductImage = $(this).attr('data-product-image-large'),
                thisProductImageSecondary = $(this).attr('data-product-image-secondary'),
                thisProductURL = $(this).attr('data-product-url');

                if (thisProductID == productID) {
                    thisProductColour = thisProductColour + " primary-product active";
                }

                var list = '<li class="'+thisProductColour+'" data-product-id="'+thisProductID+'" data-product-image="'+thisProductImage+'" data-product-image-secondary="'+thisProductImageSecondary+'" data-product-url="'+thisProductURL+'"></li>';

            //if product has colour....then append it.
            if (thisProductColour) {    
                if (thisProductID == productID) {
                    $('.collection-listing .product-single[data-product-id="'+productID+'"] .product-colours ul').prepend(list);
                } else {
                    $('.collection-listing .product-single[data-product-id="'+productID+'"] .product-colours ul').append(list);
                }
            }

            //if more than one colour, show colours.
            if ($('.collection-listing .product-single[data-product-id="'+productID+'"] .product-colours li').length > 1) {
                $('.collection-listing .product-single[data-product-id="'+productID+'"] .product-colours').removeClass('d-none');
            }
        });
    })
}

//BG: used in conjuction with the above function, once the above function has ran, we then need to allow the user to switch between the colours, and show image and update the product link.
function collectionProductColourSwitcher() {
    var productColours = $('.collection-listing .product-colours li'),
        interactionType = "";

    if ($(window).width() <= screenMD) {
        interactionType = "click";
    } else {
        interactionType = "mouseover";
    }

    productColours.on(interactionType, function() {
        var productImage = $(this).attr('data-product-image'),
            productImageSecondary = $(this).attr('data-product-image-secondary'),
            productURL = $(this).attr('data-product-url'),
            productID = $(this).attr('data-product-id'),
            parentProductID = $(this).closest('#product_single').attr('data-product-id'),
            productColours = $(this).closest('#product_single').find('.product-colours li'),
            primaryImage = $(this).closest('#product_single').find('.product-image img'),
            parentProductURL = $(this).closest('#product_single').find('a'),
            quickView = $(this).closest('#product_single22222222').find('.product-quickview span');

            productColours.removeClass('active');
            $(this).addClass('active');

            primaryImage.attr('src', productImage);
            primaryImage.attr('data-second-image', productImageSecondary);
            parentProductURL.attr('href', productURL);
            quickView.attr('data-product-url222', productURL);
    });
}

//On the initial page load, set the sorting option to the first option.
function sortFilter() {
    if (!getUrlParameter('sort')) {
        $( window ).one( "load", function() {
            $('#bc-sf-filter-top-sorting select option:first').attr("selected",true);
        });
    }
}

//BG: Changing the method of adding a second image. Rather than loading in the image as default, i'm loading in the URL to the second image, and will load it on hover.
function collectionProductHover() {
    $('.collection-listing .product-single .product-image-hover img').on("mouseenter", function(){
        var firstImage = $(this).attr('data-src'),
            secondImage = $(this).attr('data-second-image');
            
            $(this).attr('data-src',secondImage);
            $(this).attr('src',secondImage);
            $(this).attr('data-srcset',secondImage);
            $(this).attr('srcset',secondImage);
            $(this).attr('data-second-image',firstImage);
    });
    $('.collection-listing .product-single .product-image-hover img').on("mouseleave", function(){
        var secondImage = $(this).attr('data-src'),
            firstImage = $(this).attr('data-second-image');
            
            $(this).attr('data-src',firstImage);
            $(this).attr('src',firstImage);
            $(this).attr('data-srcset',firstImage);
            $(this).attr('srcset',firstImage);
            $(this).attr('data-second-image',secondImage);
    });
}

collectionReadMore();
collectionViews();
filterToggle();
collectionProductHover();
collectionFilterMobileActions();
collectionSortByMobile();
collectionFiltersMobileClose();
//LM: Below functions called in Product Filter and Search file.
//On the initial page load, set the sorting option to the first option.
function sortFilter() {
    if (!getUrlParameter('sort')) {
        $( window ).one( "load", function() {
            $('#bc-sf-filter-top-sorting select option:first').attr("selected",true);
        });
    }
}
// =require templates/cart.js
function forgotPassword() {

    var loginForm = $('#CustomerLoginForm'),
        passwordForm = $('#RecoverPasswordForm');

    $('.show-forgot-password').click(function(){
        loginForm.addClass('hide');
        passwordForm.removeClass('hide');
    });

    $('.hide-forgot-password').click(function(){
        loginForm.removeClass('hide');
        passwordForm.addClass('hide');
    });
}

function resetPasswordForm() {
    var formState = $('.reset-password-success')

    if (formState.length) {
        $('#ResetSuccess').removeClass('hide');
    }
}


//BG: Tokyo Laundry want to capture Birthdays.
function birthdayFormat(form) {
    var birthdayField = form.find('#Birthday'),
        birthdayFieldValue = 'Day/Month/Year',
        birthdayDay = form.find('#birthday-day'),
        birthdayDayValue = '',
        birthdayMonth = form.find('#birthday-month'),
        birthdayMonthValue = '',
        birthdayYear = form.find('#birthday-year'),
        birthdayYearValue = '';
    
    function combinedValue() {
        birthdayFieldValue = birthdayDayValue +' '+birthdayMonthValue +' '+ birthdayYearValue;
        birthdayField.val(birthdayFieldValue);
    }    

    birthdayDay.on('change', function(){
        birthdayDayValue = $(this).val();
        combinedValue();
    });

    birthdayMonth.on('change', function(){
        birthdayMonthValue = $(this).val();
        combinedValue();
    });

    birthdayYear.on('change', function(){
        birthdayYearValue = $(this).val();
        combinedValue();
    });
}

//BG: Check to see if the form is valid.
function checkFormValidation(form) {
    var invalidFields = form.find('label.required'),
        invalidFieldsCount = 0,
        validFieldsCount = 0;

    invalidFields.each(function(){
        if ($(this).hasClass('validated')) {
            validFieldsCount++;
        } else {
            invalidFieldsCount++;
        }
    });
    if (invalidFieldsCount === 0) {
        form.removeClass('validation-invalid');
    }

    console.log('invalid count:'+invalidFieldsCount);
    console.log('valid count:' +validFieldsCount);
}

//BG: build error message, what the message contains and where it should output.
function feedbackMessage(field, status, message,form) {
    var messageNoWhitespace = field.replace(/\s/g, ""),
        html = "<div class='ajaxfeedback "+status+" "+messageNoWhitespace+"'>"+message+"</div>";

    //if error messages are already showing, don't show again.
    if ($('.ajaxfeedback.' + messageNoWhitespace).length == 0) {
        form.before(html);
    }
}

function confirmPasswords(form) {
    $('#CreatePassword').on('input', function(){
        var passwordOneValue = $('#PasswordOne').val(),
            passwordTwoValue = $('#CreatePassword').val();

        if (passwordOneValue != passwordTwoValue) {
            $('.ajaxfeedback.Password').remove();
            feedbackMessage('Password','error','Passwords do not match',form);
            $('label.password-required').removeClass('validated');
        } else {
            $('.ajaxfeedback.Password').remove();
            $('label.password-required').addClass('validated');
            feedbackMessage('Password','success','Passwords match',form);
            checkFormValidation(form);
        }
    });  
}


//BG: Check input values
function checkRequiredFields(form) {
    var formFields = form.find('input.required:not(.password-required)'),
        passwordFields = form.find('input.password-required');

    //For each required field....
    formFields.each(function(){
        //on input should detect: paste, right click, deleting text or typing text. 
        $(this).on('input', function(){
            var thisValue = $(this).val(),
                label = $(this).attr('id'),
                labelNoWhitespace = label.replace(/\s/g, "");

            //If the value is greater than 0
            //add valid input classes and remove invalid messages
            if (thisValue.length > 0) {
                $(this).addClass('input-valid');
                $(this).removeClass('input-invalid');
                $('label[for="' + labelNoWhitespace + '"]').addClass('validated')
                $('.ajaxfeedback.'+labelNoWhitespace).remove();
                checkFormValidation(form);
            } else {
                $(this).removeClass('input-valid');
                $(this).addClass('input-invalid');
                $('label[for="' + labelNoWhitespace + '"]').removeClass('validated')
            }
        });
    });

    if (passwordFields.length > 0) {
        confirmPasswords(form);
    }
}

//Highlighted the required fields to the user, and output error message.
function highlightRequiredFields(form) {
    //get list of labels
    var invalidFormLabels = form.find('label.required:not(.validated)'),
        once = 0;

    invalidFormLabels.each(function(){
        if ($(this).hasClass('password-required')) {
            //Run once
            if (once == 0) {
                feedbackMessage('Password','error','<strong>Password</strong> this field is required.',form);
                once++;
            }
        } else {
            var labelValue = $.trim($(this).text());
            feedbackMessage(labelValue,'error','<strong>'+labelValue+'</strong> this field is required.',form)
        }
    })

}

/* 
BG: Basic form validation intended for the registration form.
*/
function registrationFormValidation() {
    var registrationForm = $('#create_customer');

    checkRequiredFields(registrationForm);
    birthdayFormat(registrationForm);

    registrationForm.on('submit', function(e) {
        //If class is present, don't submit form.
        if ($(this).hasClass('validation-invalid')) {
            e.preventDefault();
            highlightRequiredFields(registrationForm);
        } 
    });
}

function addressEditDelete() {

    //Delete Address, confirm user action.    
    $('.address-delete').on('click', function() {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
        }
    });
    
    //Toggle edit address
    $('.edit-address').on('click', function() {
        var formId = $(this).attr('data-form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
          
        if ($(this).hasClass('address-edit-primary')) {
            $(this).addClass('hide');
        }
          
        if ($(this).hasClass('address-edit-secondary')) {
            $('.address-edit-primary').removeClass('hide');
        }
    });
}

function accountNavigation() {
    var accountSidebarTitle = $('.account-sidebar h3'),
        accountSidebarNavigation = $('.account-sidebar-navigation');

   accountSidebarTitle.on('click', function(){
        accountSidebarTitle.toggleClass('active');
        accountSidebarNavigation.toggleClass('active');
   });   
}

function retrieveOrderInfo() {
    var orderItem = $('.account-orders .account-orders-row'),
    allOrderContainer = $('.account-orders .account-orders-row .order-details');

    orderItem.each(function(){
        var orderLink = $(this).find('.orderNumber'),
        orderLinkHref = $(this).find('.orderNumber').attr('href'),
        orderContainer = $(this).find('.order-details');

        $(orderLink).on('click', function(e){
            e.preventDefault();

            if($(orderContainer).is(':empty')) {
                $.ajax({
                    method: 'GET',
                    url: orderLinkHref,
                    dataType: 'html',
                    success: function (data) {
                        $(allOrderContainer).slideUp();
                        $(allOrderContainer).removeClass('active');
                        $(orderContainer).html($(data).find(".order-container"));
                        $(orderContainer).slideDown();
                        $(orderContainer).addClass("active");
                        
                        var productSlick = $(orderContainer).find('.account-product-slick');

                        slicksettings = {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: false,
                            dots: true,
                            arrows: false
                        }
                          
                        if ($(window).width() < screenLG) {
                            productSlick.slick(slicksettings);
                        }
                      
                        // reslick only if it's not slick()
                        $(window).on('resize', function() {
                           if ($(window).width() > screenLG) {
                             if (productSlick.hasClass('slick-initialized')) {
                                productSlick.slick('unslick');
                             }
                             return
                           } else {
                               if (!productSlick.hasClass('slick-initialized')) {
                                 return productSlick.slick(slicksettings);
                               }
                           }
                        });
                    }
                });
            } else if (!$(orderContainer).hasClass('active')) {
                $(allOrderContainer).slideUp();
                $(allOrderContainer).removeClass('active');
                $(orderContainer).slideDown();
                $(orderContainer).addClass("active");
            } else {
                $(orderContainer).slideUp();
                $(orderContainer).removeClass('active');
            }
        })
    });
}

addressEditDelete();
resetPasswordForm();
forgotPassword();
registrationFormValidation();
accountNavigation();
retrieveOrderInfo();
function infoMenuConfig() {
    
    //MJ: Nav on the Customer Service page
    var infoNavItems = $('.info__nav ul li a');

    var mobNavOpen = $('#mob__info__nav__open'),
    mobNavOpenText = $('#mob__info__nav__open .text'),
    overlay = $('.info-overlay'),
    bodyId = document.getElementsByTagName("body")[0].id,
    mobChevron = $('.mob__chevron');

    //MJ: Fix to & sign not being included in the ID. Will need rework if T&C page changes.
    if (bodyId.includes('-amp-')) {
        bodyId = bodyId.replace("-amp-", "-");
    }

    //MJ: If the current page's body id matches an item in the side menu, add an active class to it,
    //and add the text to the mobile version
    infoNavItems.each(function(){
        var itemURL = $(this).attr('data-url'),
        itemTitle = $(this).attr('data-title');

        if (itemURL.includes(bodyId)) {
            $(this).addClass('current');
            mobNavOpenText.text(itemTitle);
        }
    });

    mobNavOpen.off('click').on('click', function(e) {
        $('.info__nav').addClass('open');
        $('.info__nav__mob').addClass('open');
        overlay.addClass('active');
    });

    overlay.click(function() {
        $(this).removeClass('active');
        $('.info__nav').removeClass('open');
        $('.info__nav__mob').removeClass('open');
    });

    mobChevron.click(function() {
        overlay.removeClass('active');
        $('.info__nav').removeClass('open');
        $('.info__nav__mob').removeClass('open');
    });
}


if ($('body.template-page').length) {
    infoMenuConfig();
}

  //Accordion Functionality.
  function accordionToggle() {
    var accordionTitle = $('.accordion-title');
    
    $('.accordion-item.active .accordion-content').show();
    
    accordionTitle.click(function(){
        if ($(this).parent('.accordion-item').hasClass('active')) {
            $(this).parent('.accordion-item').removeClass('active');
            $(this).next('.accordion-content').slideUp();
        } else {
            
            $('.accordion-item').removeClass('active');
            $('.accordion-content').slideUp();
            
            $(this).parent('.accordion-item').addClass('active');
            $(this).next('.accordion-content').slideDown();
        }
    })
}

accordionToggle();
function BlogRelatedSlider() {
    $('.dib-related-posts').each(function(){
        var categorySlick = $(this);

        var categoryPrevArrow = "<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg width='50px' height='100px' viewBox='0 0 50 100' version='1.1'><g id='carousel_indicator_left' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><g id='Group'><path d='M50,100 C50,100 50,0 50,0 C22.3857625,0 0,22.3857625 0,50 C0,77.6142375 22.3857625,100 50,100 Z' id='Oval' fill='#C8A07D' transform='translate(25.000000, 50.000000) scale(-1, 1) translate(-25.000000, -50.000000) '></path><polyline id='Path-3' stroke='#FFFFFF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' transform='translate(16.666667, 50.000000) scale(-1, 1) rotate(-90.000000) translate(-16.666667, -50.000000) ' points='8.33333333 45.8333333 16.6666667 54.1666667 25 45.8333333'></polyline></g></g></svg></button>",
            categoryNextArrow = "<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg width='50px' height='100px' viewBox='0 0 50 100' version='1.1'><g id='carousel_indicator_right' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><g id='Carousel-left' transform='translate(25.000000, 50.000000) scale(-1, 1) translate(-25.000000, -50.000000) '><path d='M50,100 C50,100 50,0 50,0 C22.3857625,0 0,22.3857625 0,50 C0,77.6142375 22.3857625,100 50,100 Z' id='Oval' fill='#C8A07D' transform='translate(25.000000, 50.000000) scale(-1, 1) translate(-25.000000, -50.000000) '></path><polyline id='Path-3' stroke='#FFFFFF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' transform='translate(16.666667, 50.000000) scale(-1, 1) rotate(-90.000000) translate(-16.666667, -50.000000) ' points='8.33333333 45.8333333 16.6666667 54.1666667 25 45.8333333'></polyline></g></g></svg></button>";

        slicksettings = {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            arrows: true,
            prevArrow: categoryPrevArrow,
            nextArrow: categoryNextArrow,
            responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.25,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1.25,
                    slidesToScroll: 1,
                }
            }
            ]
        }

        categorySlick.slick(slicksettings);
    });
}

$(document).ready(function() {    
    BlogRelatedSlider();
});
$('.nav-A').click(function() {
  $('.active').removeClass('active');   
  $('.title-A').addClass('active');
});

$('.nav-B').click(function() {
  $('.active').removeClass('active');   
  $('.title-B').addClass('active');
});

$('.nav-C').click(function() {
  $('.active').removeClass('active');   
  $('.title-C').addClass('active');
});

$('.nav-C').click(function() {
  $('.active').removeClass('active');   
  $('.title-C').addClass('active');
});

$('.nav-D').click(function() {
  $('.active').removeClass('active');   
  $('.title-D').addClass('active');
});

$('.nav-E').click(function() {
  $('.active').removeClass('active');   
  $('.title-E').addClass('active');
});

$('.nav-F').click(function() {
  $('.active').removeClass('active');   
  $('.title-F').addClass('active');
});

$('.nav-G').click(function() {
  $('.active').removeClass('active');   
  $('.title-G').addClass('active');
});

$('.nav-H').click(function() {
  $('.active').removeClass('active');   
  $('.title-H').addClass('active');
});

$('.nav-I').click(function() {
  $('.active').removeClass('active');   
  $('.title-I').addClass('active');
});


$('.nav-J').click(function() {
  $('.active').removeClass('active');   
  $('.title-J').addClass('active');
});

$('.nav-K').click(function() {
  $('.active').removeClass('active');   
  $('.title-K').addClass('active');
});

$('.nav-L').click(function() {
  $('.active').removeClass('active');   
  $('.title-L').addClass('active');
});

$('.nav-M').click(function() {
  $('.active').removeClass('active');   
  $('.title-M').addClass('active');
});

$('.nav-N').click(function() {
  $('.active').removeClass('active');   
  $('.title-N').addClass('active');
});

$('.nav-O').click(function() {
  $('.active').removeClass('active');   
  $('.title-O').addClass('active');
});

$('.nav-P').click(function() {
  $('.active').removeClass('active');   
  $('.title-P').addClass('active');
});

$('.nav-Q').click(function() {
  $('.active').removeClass('active');   
  $('.title-Q').addClass('active');
});

$('.nav-R').click(function() {
  $('.active').removeClass('active');   
  $('.title-R').addClass('active');
});

$('.nav-S').click(function() {
  $('.active').removeClass('active');   
  $('.title-S').addClass('active');
});

$('.nav-T').click(function() {
  $('.active').removeClass('active');   
  $('.title-T').addClass('active');
});

$('.nav-U').click(function() {
  $('.active').removeClass('active');   
  $('.title-U').addClass('active');
});

$('.nav-V').click(function() {
  $('.active').removeClass('active');   
  $('.title-V').addClass('active');
});

$('.nav-W').click(function() {
  $('.active').removeClass('active');   
  $('.title-W').addClass('active');
});

$('.nav-Z').click(function() {
  $('.active').removeClass('active');   
  $('.title-Z').addClass('active');
});

(function($) {
  $('.button-control').click(function() {
    $(this).addClass('active-a-z').siblings('li').removeClass('active-a-z');
    $('section:nth-of-type('+$(this).data('rel')+')').stop().fadeIn(400, 'linear').siblings('section').stop().fadeOut(400, 'linear'); 
  });
})(jQuery);

/*================ Sections ================*/
// Used with sections/header-text-features.liquid
function textFeaturesSlick() {    
    $slick_slider = $('.text-features-slick');
    slicksettings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 1000,
        prevArrow: slickPrevArrow,
        nextArrow: slickNextArrow,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,

                autoplay: true,
                autoplaySpeed: 2000,
            }
          }
        ]
    }
      
    $slick_slider.slick(slicksettings);
}

$(document).ready(function() {    
    textFeaturesSlick();
});
//Open and close the mobile Search
function siteSearch() {
    var searchIcon = $('#site-header .header-search-icon'),
        searchBar = $('.search-bar');

    searchIcon.click(function(){
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            searchBar.slideUp();
        } else {
            $(this).addClass('active');
            searchBar.slideDown();
            searchBar.find('input').focus();
        }
    });
}

//Toggle open and close of mobile navigation
function mobileNavigationMenuToggle() {
    var menuIcon = $('#site-header .header-mobile-menu'),
        menu = $('#site-navigation'),
        header = $('#site-header'),
        overlay = $('.nav-overlay');
 
    menuIcon.click(function(){
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            menu.removeClass('active');
            header.removeClass('menu-open');
            overlay.removeClass('active');

        } else {
            $(this).addClass('active');
            menu.addClass('active');
            header.addClass('menu-open');
            overlay.addClass('active');
        }
    }); 
 
    overlay.click(function() {
        $(this).removeClass('active');
        menu.removeClass('active');
        header.removeClass('menu-open');
        menuIcon.removeClass('active');
    })
}

//Toggle open and close of the individual links within the navigation.
function mobileNavigation() {
    var parentLink = $('#site-navigation .has-child > a'),
        secondaryLink = $('#site-navigation .sub-menu-title'),
        parentBackLink = $('.mobile-menu-actions .menu-back'),
        secondaryBackLink = $('.grandchild-mobile-menu-actions .menu-back'),
        tabLinks = $('#site-navigation .mobile-navigation-tabs ul li a'),
        primaryNavigation = $('#site-navigation .top-level'),
        secondaryNavigation = $('#site-navigation .account-navigation-links');
    
        //console.log('screenSM and Lower');
        
        //unbind and bind click action - can cause issues when resizing browser
        parentLink.off('click').on('click', function(e) {
            //print anchor from working.
            e.preventDefault();
            
            //add active class to parent and slide down child menus.
            if ($(this).parent('li').hasClass('active')) {
                $(this).parent('li').removeClass('active');    
                $(this).next('.sub-menu-container').removeClass('open');
            } else {
                parentLink.parent('li').removeClass('active');
                parentLink.next('.sub-menu-container').removeClass('open');
                $(this).parent('li').addClass('active');
                $(this).next('.sub-menu-container').addClass('open');
            }
        });

        //unbind and bind click action - can cause issues when resizing browser
        secondaryLink.off('click').on('click', function(e) {
            //print anchor from working.
            e.preventDefault();
            
            //add active class to parent and slide down child menus.
            if ($(this).parents('li').hasClass('active')) {
                
                secondaryLink.parents('li').removeClass('active');
                secondaryLink.next('ul').removeClass('open');
                $(this).parents('li').addClass('active');
                $(this).next('.grandchild__menu__holder').addClass('open');
            } else {
                $(this).parents('li').removeClass('active');    
                $(this).next('.grandchild__menu__holder').removeClass('open');
            }
        });

         //return the user to the main menu
         parentBackLink.off('click').on('click', function(e) {
            $(this).parents('li.active').find('.sub-menu-container').removeClass('open');
            $(this).parents('li.active').removeClass('active');
        });
        
         //return the user to the main menu
         secondaryBackLink.off('click').on('click', function(e) {
            $(this).parents('li.active').find('.grandchild__menu__holder').removeClass('open');
            // $(this).parents('li.active').removeClass('active');
        });


        tabLinks.off('click').on('click', function(e){
            e.preventDefault();

            var hash = $(this).attr('href');
            
            if (hash == "#account") {
                primaryNavigation.addClass('d-none');
                secondaryNavigation.removeClass('d-none');
                $('#site-navigation .mobile-navigation-tabs ul li').removeClass('active');
                $(this).parent().addClass('active');
            } else {
                primaryNavigation.removeClass('d-none');
                secondaryNavigation.addClass('d-none');
                $('#site-navigation .mobile-navigation-tabs ul li').removeClass('active');
                $(this).parent().addClass('active');
            }

        });

        $('#site-navigation').addClass('transition');
        
    
}

function desktopNavigation() {
    var mainNavigation = $('#site-navigation'),
        navOverlay = $('.nav-overlay'),
        parentLink = $('#site-navigation .has-child');
    
    if ($(window).width() >= screenLG) {
        //console.log('Screen LG & Greater');
        
        parentLink.on("mouseover", function() {
            $(this).addClass('active');  
            $(this).find('.menu').addClass('active');
            navOverlay.addClass('active');

            //UPDATE
            //BG: for performance reasons, we are now going to load the images within the mega menu when the user hovers on the menu.

            var navigationImages = $(this).find('.sub-menu-image img');
            navigationImages.each(function(){
                var imageURL = $(this).attr('data-image-url')
                if (imageURL) {
                    $(this).attr('src',imageURL);
                    $(this).removeClass('img-full');
                }
            });
        

        });
        
        parentLink.on("mouseout", function() {
            $(this).removeClass('active');  
            $(this).find('.menu').removeClass('active');
            navOverlay.removeClass('active');
        });

        
        
    } else {
        //console.log('Lower than Screen LG');
        mainNavigation.off("mouseover");
        mainNavigation.off("mouseout");
        parentLink.off("mouseover");
        parentLink.off("mouseout");
    }
}

//BG: Need to move the navigation when on mobile so it doesn't clash with the fixed header.
function moveNavigation() {

    var navigationContainer = $('.site-navigation-container'),
        bodyContainer = $('.body-container'),
        navOverlay = $('.nav-overlay'),
        navigation = $('#site-navigation');


    if ($(window).width() <= screenLG) {
        
        navigation.insertBefore(bodyContainer);
        navOverlay.insertBefore(bodyContainer);

    } else {
        navigationContainer.append(navigation);
        navOverlay.insertAfter('#MainContent');
    }
}

//BG: Because the header is fixed, we need to add padding to ensure nothing is hidden behind the header.
function headSpaceFix() {
    var header = $('#site-header');

    var headerHeight = header.outerHeight(true);
    
    $('body').css('padding-top',headerHeight);
}

function headroom() {
    // grab an element
    var header = document.querySelector("header");
    // construct an instance of Headroom, passing the element
    var headroomHeader  = new Headroom(header, {
        "offset": 150
    });
    // initialise
    headroomHeader.init(); 
}

function countrySelect() {
    var currentCountry = $('.current-country li');

    currentCountry.click(function(){
        $(this).toggleClass('active');
    });
}

function cartSlide() {
    $('.header-basket a').off().on('click', function(e){
        e.preventDefault();

        if($(this).hasClass('active')) {
            $(this).removeClass('active');
            $('.cart-mini-contents').removeClass('active');
        } else {
            $(this).addClass('active');
            $('.cart-mini-contents').addClass('active');
//           console.log('open')

//           if(typeof WSAIO !== "undefined" && typeof WSAIO.productDiscount === "function"){
//             setTimeout(function(){
//               console.log('22222222222222')
//               WSAIO.preCheckout();
//               WSAIO.checkoutEventListner();
//             },1000)


//           }
        }
    });
}

$(document).ready(function() {    
    siteSearch();
    mobileNavigationMenuToggle();
    mobileNavigation()
    desktopNavigation();
    headroom();
    headSpaceFix();
    moveNavigation();
    countrySelect();
    cartSlide();

});

$(window).on('resize',function() {
    mobileNavigation();
    desktopNavigation();
    headSpaceFix();
    moveNavigation();
});
function footerLinks() {
    var footerTitle = $('footer .footer-title:not(.nocollapse)'),
        footerContent = $('footer .footer-content');

    if ($(window).width() < screenLG) {
        
        footerTitle.off('click').on('click', function(){
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).next('.footer-content').slideUp();
            } else {
                $(this).addClass('active');
                $(this).next('.footer-content').slideDown();
            }
        });
        
    } else {
        footerTitle.off('click');
        footerContent.css('display', '');
    }
}

footerLinks();

$(window).on('resize',function() {
    footerLinks();
});
function featuredImagesSlick() {
    $('.featured-images-slider-slick').slick({
        prevArrow: slickPrevArrow,
        nextArrow: slickNextArrow
    });

    var stHeight = $('.featured-images-slider-slick .slick-track').height();
    $('.featured-images-slider-slick .slick-slide').css('height',stHeight + 'px' );
}

featuredImagesSlick();
function featuredProductsSlick() {
    var categoryPrevArrow = "<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg width='50px' height='100px' viewBox='0 0 50 100' version='1.1'><g id='carousel_indicator_left' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><g id='Group'><path d='M50,100 C50,100 50,0 50,0 C22.3857625,0 0,22.3857625 0,50 C0,77.6142375 22.3857625,100 50,100 Z' id='Oval' fill='#C8A07D' transform='translate(25.000000, 50.000000) scale(-1, 1) translate(-25.000000, -50.000000) '></path><polyline id='Path-3' stroke='#FFFFFF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' transform='translate(16.666667, 50.000000) scale(-1, 1) rotate(-90.000000) translate(-16.666667, -50.000000) ' points='8.33333333 45.8333333 16.6666667 54.1666667 25 45.8333333'></polyline></g></g></svg></button>",
    categoryNextArrow = "<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg width='50px' height='100px' viewBox='0 0 50 100' version='1.1'><g id='carousel_indicator_right' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><g id='Carousel-left' transform='translate(25.000000, 50.000000) scale(-1, 1) translate(-25.000000, -50.000000) '><path d='M50,100 C50,100 50,0 50,0 C22.3857625,0 0,22.3857625 0,50 C0,77.6142375 22.3857625,100 50,100 Z' id='Oval' fill='#C8A07D' transform='translate(25.000000, 50.000000) scale(-1, 1) translate(-25.000000, -50.000000) '></path><polyline id='Path-3' stroke='#FFFFFF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' transform='translate(16.666667, 50.000000) scale(-1, 1) rotate(-90.000000) translate(-16.666667, -50.000000) ' points='8.33333333 45.8333333 16.6666667 54.1666667 25 45.8333333'></polyline></g></g></svg></button>";

    $('section.featured-products .featured-products-slick').each(function(){
        $(this).slick({
            lazyLoad: 'ondemand',
            prevArrow: categoryPrevArrow,
            nextArrow: categoryNextArrow
        });
    });
}

if (!$('body.template-product').length) {
    featuredProductsSlick();
}
function heroSlickInit() {
    $('.hero-slick').each(function(){
        var heroSlick = $(this);
        $(heroSlick).slick({
                prevArrow: slickPrevArrow,
                nextArrow: slickNextArrow
        });
    });
}

heroSlickInit();
function collectionSlider() {

    var categoryPrevArrow = "<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg width='50px' height='100px' viewBox='0 0 50 100' version='1.1'><g id='carousel_indicator_left' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><g id='Group'><path d='M50,100 C50,100 50,0 50,0 C22.3857625,0 0,22.3857625 0,50 C0,77.6142375 22.3857625,100 50,100 Z' id='Oval' fill='#C8A07D' transform='translate(25.000000, 50.000000) scale(-1, 1) translate(-25.000000, -50.000000) '></path><polyline id='Path-3' stroke='#FFFFFF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' transform='translate(16.666667, 50.000000) scale(-1, 1) rotate(-90.000000) translate(-16.666667, -50.000000) ' points='8.33333333 45.8333333 16.6666667 54.1666667 25 45.8333333'></polyline></g></g></svg></button>",
    categoryNextArrow = "<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg width='50px' height='100px' viewBox='0 0 50 100' version='1.1'><g id='carousel_indicator_right' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><g id='Carousel-left' transform='translate(25.000000, 50.000000) scale(-1, 1) translate(-25.000000, -50.000000) '><path d='M50,100 C50,100 50,0 50,0 C22.3857625,0 0,22.3857625 0,50 C0,77.6142375 22.3857625,100 50,100 Z' id='Oval' fill='#C8A07D' transform='translate(25.000000, 50.000000) scale(-1, 1) translate(-25.000000, -50.000000) '></path><polyline id='Path-3' stroke='#FFFFFF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' transform='translate(16.666667, 50.000000) scale(-1, 1) rotate(-90.000000) translate(-16.666667, -50.000000) ' points='8.33333333 45.8333333 16.6666667 54.1666667 25 45.8333333'></polyline></g></g></svg></button>";

    $('.collection-scroller-slick').slick({
        prevArrow: categoryPrevArrow,
        nextArrow: categoryNextArrow
    });
}

collectionSlider();
function categorySlider() {
    $('.category-slick').each(function(){
        var categorySlick = $(this);
        var blockAmount = categorySlick.attr('data-blocks');

        var categoryPrevArrow = "<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg width='50px' height='100px' viewBox='0 0 50 100' version='1.1'><g id='carousel_indicator_left' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><g id='Group'><path d='M50,100 C50,100 50,0 50,0 C22.3857625,0 0,22.3857625 0,50 C0,77.6142375 22.3857625,100 50,100 Z' id='Oval' fill='#C8A07D' transform='translate(25.000000, 50.000000) scale(-1, 1) translate(-25.000000, -50.000000) '></path><polyline id='Path-3' stroke='#FFFFFF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' transform='translate(16.666667, 50.000000) scale(-1, 1) rotate(-90.000000) translate(-16.666667, -50.000000) ' points='8.33333333 45.8333333 16.6666667 54.1666667 25 45.8333333'></polyline></g></g></svg></button>",
            categoryNextArrow = "<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg width='50px' height='100px' viewBox='0 0 50 100' version='1.1'><g id='carousel_indicator_right' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><g id='Carousel-left' transform='translate(25.000000, 50.000000) scale(-1, 1) translate(-25.000000, -50.000000) '><path d='M50,100 C50,100 50,0 50,0 C22.3857625,0 0,22.3857625 0,50 C0,77.6142375 22.3857625,100 50,100 Z' id='Oval' fill='#C8A07D' transform='translate(25.000000, 50.000000) scale(-1, 1) translate(-25.000000, -50.000000) '></path><polyline id='Path-3' stroke='#FFFFFF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' transform='translate(16.666667, 50.000000) scale(-1, 1) rotate(-90.000000) translate(-16.666667, -50.000000) ' points='8.33333333 45.8333333 16.6666667 54.1666667 25 45.8333333'></polyline></g></g></svg></button>";

        slicksettings = {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            arrows: true,
            prevArrow: categoryPrevArrow,
            nextArrow: categoryNextArrow,
            responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.25,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1.25,
                    slidesToScroll: 1,
                }
            }
            ]
        }

        if ($(window).width() > screenMD) {
            if(blockAmount > 3) {
                categorySlick.slick(slicksettings);
            }
        } else {
            if(blockAmount > 1) {
                categorySlick.slick(slicksettings);
            }
        }
    });

    $('.downloads-slick').each(function(){
        var downloadSlick = $(this);
        var blockAmount = downloadSlick.attr('data-blocks');

        var categoryPrevArrow = "<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg width='50px' height='100px' viewBox='0 0 50 100' version='1.1'><g id='carousel_indicator_left' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><g id='Group'><path d='M50,100 C50,100 50,0 50,0 C22.3857625,0 0,22.3857625 0,50 C0,77.6142375 22.3857625,100 50,100 Z' id='Oval' fill='#C8A07D' transform='translate(25.000000, 50.000000) scale(-1, 1) translate(-25.000000, -50.000000) '></path><polyline id='Path-3' stroke='#FFFFFF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' transform='translate(16.666667, 50.000000) scale(-1, 1) rotate(-90.000000) translate(-16.666667, -50.000000) ' points='8.33333333 45.8333333 16.6666667 54.1666667 25 45.8333333'></polyline></g></g></svg></button>",
            categoryNextArrow = "<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg width='50px' height='100px' viewBox='0 0 50 100' version='1.1'><g id='carousel_indicator_right' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><g id='Carousel-left' transform='translate(25.000000, 50.000000) scale(-1, 1) translate(-25.000000, -50.000000) '><path d='M50,100 C50,100 50,0 50,0 C22.3857625,0 0,22.3857625 0,50 C0,77.6142375 22.3857625,100 50,100 Z' id='Oval' fill='#C8A07D' transform='translate(25.000000, 50.000000) scale(-1, 1) translate(-25.000000, -50.000000) '></path><polyline id='Path-3' stroke='#FFFFFF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' transform='translate(16.666667, 50.000000) scale(-1, 1) rotate(-90.000000) translate(-16.666667, -50.000000) ' points='8.33333333 45.8333333 16.6666667 54.1666667 25 45.8333333'></polyline></g></g></svg></button>";

        slicksettings = {
            slidesToShow: 5,
            slidesToScroll: 5,
            infinite: false,
            arrows: true,
            prevArrow: categoryPrevArrow,
            nextArrow: categoryNextArrow,
            responsive: [
            {
                breakpoint: 999,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            }
            ]
        }

        if ($(window).width() > screenMD) {
            if(blockAmount > 5) {
                downloadSlick.slick(slicksettings);
            }
        } else {
            if(blockAmount > 1) {
                downloadSlick.slick(slicksettings);
            }
        }
    });
}

  
    categorySlider();

function topSlick() {    
    $slick_slider = $('.top-height');
    
    slicksettings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow: slickPrevArrow,
        nextArrow: slickNextArrow,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1
            }
          }
        ]
    }
      
    $slick_slider.slick(slicksettings);
}

$(document).ready(function() {    
    topSlick();
});
function shipping() {
    var tabs = $('.shipping-tab'),
        inlineTabs = $('.shipping-tab-title'),
        tabsContent = $('.shipping-tab-content');
        activetab = $('.active');
  
        tabs.on('click', function(){
            tabs.removeClass('active');
            $(this).addClass('active');
  
            var tabName = $(this).attr('data-tab');
  
            inlineTabs.removeClass('active');
            $('.shipping-tab-title[data-tab="'+tabName+'"]').addClass('active');
  
            tabsContent.removeClass('active');
            $('.shipping-tab-content[data-tab="'+tabName+'"]').addClass('active');
        });
  
        inlineTabs.on('click', function(){
            var tabName = $(this).attr('data-tab');
  
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $('.shipping-tab-content[data-tab="'+tabName+'"]').removeClass('active');
            } else {
                inlineTabs.removeClass('active');
                $(this).addClass('active');
  
                tabs.removeClass('active');
                $(' .shipping-tab[data-tab="'+tabName+'"]').addClass('active');
  
                tabsContent.removeClass('active');
                $('.shipping-tab-content[data-tab="'+tabName+'"]').addClass('active');
            }
        });
        
  }

  shipping();


function ribonSlider() {    
  
    $('.top-height').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
            {
            breakpoint: 768,
            settings: {
                slidesToShow: 1
            }
            },
            {
            breakpoint: 576,
            settings: {
                slidesToShow: 1
            }
            }
        ]
        });
    }             
    
    $(document).ready(function() {    
    ribonSlider();
    });

      
$(".close-icon").click(function(){
    $(".cart-mini-contents").removeClass("active");
  
    $(".header-basket a").removeClass("active");
    }); 


/**
     * Velstar Ajaxify Cart
     **/
 var config = {

    /* Langauge */
    addToCartBtnText:         'Add to basket', //Add to Basket
    addedToCartBtnText:     'Added to basket', //Added to Basket
    addingToCartBtnText:     'Adding', //Adding...
    soldOutBtnText:         'Sold out', //Sold Out
    //After adding a product to the cart, how long to wait before it returns to normal?
    returnBtnToNormal:         4000, // milliseconds

    /* Selectors */
    cartCountSelector:         '.cart-count',
    cartTotalSelector:         '#cart-total-amount',
    cartRemoveSelector:     '.cart-prod-remove',

    /* Icons*/
    successIcon:             '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-check" viewBox="0 0 512 512"><path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>',
    errorIcon:                 '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-times" viewBox="0 0 352 512"><path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg>',
    loadingIcon:             '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-sync" viewBox="0 0 512 512"><path d="M500 8h-27.711c-6.739 0-12.157 5.548-11.997 12.286l2.347 98.575C418.212 52.043 342.256 8 256 8 134.813 8 33.933 94.924 12.296 209.824 10.908 217.193 16.604 224 24.103 224h28.576c5.674 0 10.542-3.982 11.737-9.529C83.441 126.128 161.917 60 256 60c79.545 0 147.942 47.282 178.676 115.302l-126.39-3.009c-6.737-.16-12.286 5.257-12.286 11.997V212c0 6.627 5.373 12 12 12h192c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12zm-12.103 280h-28.576c-5.674 0-10.542 3.982-11.737 9.529C428.559 385.872 350.083 452 256 452c-79.546 0-147.942-47.282-178.676-115.302l126.39 3.009c6.737.16 12.286-5.257 12.286-11.997V300c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12v192c0 6.627 5.373 12 12 12h27.711c6.739 0 12.157-5.548 11.997-12.286l-2.347-98.575C93.788 459.957 169.744 504 256 504c121.187 0 222.067-86.924 243.704-201.824 1.388-7.369-4.308-14.176-11.807-14.176z"></path></svg>',


    /* No need to change this elements. */
    addToCartBtnSelector:     '.btn-add-to-cart.variant-available',
    addToCartFormSelector:     'form[action="/cart/add"]',
    addToCartFormSelectorNew: '.featured-product form[action="/cart/add"]',
    shopifyAjaxAddURL:         '/cart/add.js',
    shopifyAjaxChangeURL:     '/cart/change.js',
    shopifyAjaxCartURL:     '/cart.js'
}

//Provide the user Feedback if the Ajax was sucessful or not.
function ajaxFeedback(status, html, $addToCartForm) {
//$('.ajaxfeedback').remove();
var feedback = '<p class="ajaxfeedback ' + status + '">' + html + '</p>';

$addToCartForm.find(config.addToCartBtnSelector).after(feedback);
$('.ajaxfeedback').slideDown();
}

//BG: Provide the user feedback on the cart template when adjusting quantity / variant.
function ajaxFeedbackCart(status,html,output) {
$('.ajaxFeedbackCart').remove();
var feedback = '<span class="ajaxFeedbackCart '+status+'">'+html+'</span>';

$(output).after(feedback);
$('.ajaxFeedbackCart').slideDown();

setTimeout(function(){
    $('.ajaxFeedbackCart').slideUp();
}, 3000);
}

//Update the button apperance during the various stages. Adding, added, and back to add.
function updateBtnText($button, label, icon) {
if ($button.children().length) {
    $button.children().each(function () {
        if (icon) {
            if ($.trim($(this).text()) !== '') {
                $(this).html(label + icon);
            }
        } else {
            if ($.trim($(this).text()) !== '') {
                $(this).text(label);
            }
        }
    });
} else {
    $button.val(label).text(label);
}
}

//Format the money
function formatMoney(cents, format) {
if (typeof cents == 'string') {
    cents = cents.replace('.', '');
}
var value = '';
var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
var formatString = (format || this.money_format);

function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
}

function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
        return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
}

switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
    case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
    case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
    case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
}

return formatString.replace(placeholderRegex, value);
};
//BG: Update the select options on the mini cart.
function updateMiniCartQuantitySelect() {
var miniCartRow = $('.header-basket .cart-row .cart-item');

miniCartRow.each(function(){
    var cartRowQuantitySelect = $(this).find('.cart-item-quantity-select'),
        cartRowQuantityValue = $(this).find('.cart-item-quantity-value').attr('value');

        cartRowQuantitySelect.find('[value="'+cartRowQuantityValue+'"]').attr('selected', true);

});

}

//BG: allows the user to update the quantity and/or variant on the cart page.
function cartItemQuantityVariant() {

    var cartItem = $('.cart-item');

    cartItem.each(function(){
        var cartQuantity = $(this).find('.quantity-controls'),
            quantitySelectId = cartQuantity.attr('data-variant-id-cart'),
            quantityDown = $(cartQuantity).find('.quantity-decrease'),
            quantityValue = $(cartQuantity).find('.cart-item-quantity-value'),
            quantityUp = $(cartQuantity).find('.quantity-increase'),
            removeAnchor = $(this).find('.cart-prod-remove');

        quantityUp.on('click',function(){
          setTimeout(function(){
            //$('[name="checkout"]').css("cssText", "display:none !important;");
          },100);
          setTimeout(function(){
            //WSAIO.cartQuantityController();
          },4000);
          setTimeout(function(){
            $('[name="checkout"]').css("cssText", "display:block !important;");
          },2000);
          var currentVal = parseInt(quantityValue.val());
            if (!isNaN(currentVal)) {
                quantityValue.val(currentVal + 1);
                quantityValue.attr('value', currentVal + 1);

                var inputAmount = quantityValue.val();
                quantityItemChange(quantitySelectId, inputAmount);
                

                setTimeout(function(){

                    updateMiniCartContents();
                },4000)
            
            }
            
        });

          quantityDown.on('click',function(){
            setTimeout(function(){
              //$('[name="checkout"]').css("cssText", "display:none !important;");
              
            },100);
            setTimeout(function(){
              // WSAIO.cartQuantityController();
            },4000);
            setTimeout(function(){
               $('[name="checkout"]').css("cssText", "display:block !important;");
            },7500);
            var currentVal = parseInt(quantityValue.val());
            if (!isNaN(currentVal) && currentVal > 1) {
                // Decrement one
                quantityValue.val(currentVal - 1);
                quantityValue.attr('value', currentVal - 1);

                var inputAmount = quantityValue.val();
                quantityItemChange(quantitySelectId, inputAmount);
                

                setTimeout(function(){

                    updateMiniCartContents();
                },4000)
            
                
            } else {
                quantityValue.val(currentVal - 1);
                quantityValue.attr('value', currentVal - 1);

                var inputAmount = quantityValue.val();
                quantityItemChange(quantitySelectId, inputAmount);

                $(removeAnchor)[0].click();
                

                setTimeout(function(){

                    updateMiniCartContents();
                },4000)
                    
            }
            

        });
    });
}

//BG: Function to update the Cart Dropdown with the newly added product(s)    
function updateMiniCartContents() {
// console.log("SSS");
//ajax get request to cart.js
$.ajax({
    type: 'GET',
    url: config.shopifyAjaxCartURL,
    dataType: 'json',
    success: function (data) {

        //Debug
        //console.log(data);

        //Get Cart Total Cost (format it) & Cart Count. 
        var cartTotalCost = slate.Currency.formatMoney(data.total_price, theme.moneyFormat),
            cartCount = data.item_count;

        //Output cart total
        $(config.cartTotalSelector).html(cartTotalCost);
        
        $(config.cartCountSelector).text(cartCount);
        if (cartCount > 0) {
            $(config.cartCountSelector).removeClass('no-items');
        } else {
            $(config.cartCountSelector).addClass('no-items');
        }


        //remove all items within cart.
        $('.cart-mini-contents .cart-row .cart-item').remove();
//            $('.quantity-controls').on("click",function(){
//               console.log("QQQQ1234");
//             })
        //with the returned data, focus soley on the items. For each item...
        $.each(data.items, function (i, item) {
            //debugging
            //console.log(item);

            var keyyy = item.key.replace(':','_');
//             console.log(keyyy);

        var itemTitle = item.product_title;
        var itemPrice = slate.Currency.formatMoney(item.price, theme.moneyFormat);
        var itemQuantity = item.quantity;
        var itemVariant = item.variant_title;
        var itemVariantId = item.variant_id;
        var itemImage = item.image;
        var itemUrl = item.url;


//add each product back to mini cart preview.
            $('.cart-mini-contents .cart-row').append('<div class="cart-item"><div class="cart-item-left"><div class="cart-prod-img"><a href="' + itemUrl + '"><img src="' + itemImage + '" class="img-fluid"></a></div><div class="cart-prod-remove"><span data-variant-id="' + itemVariantId + '">Remove</span></div></div><div class="cart-item-right"><div class="cart-prod-name"><a href="' + itemUrl + '">' + itemTitle + '</a></div><div class="cart-item-container">        <div class="cart-item-main product-quantity-container"><div class="cart-item-quantity">                              <div class="product-quantity-container product-quantity__flex-items"> <label for="Quantity-cart" class="sr-only">Quantity</label><div class="quantity-controls product-quantity" data-variant-id-cart="'+itemVariantId+'"><span class="quantity-decrease">                                         <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"></path></svg>            </span><input type="text" id="quantity-new-' + itemVariantId + '" class="cart-item-quantity-value" name="quantity-cart-new-' + itemVariantId + '" value="'+itemQuantity+'" readonly><span class="quantity-increase">                                        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"></path></svg>            </span></div></div></div></div><span class="cart-prod-price"><span class="money itm_d ws-item-price-'+keyyy+'">' + itemPrice + '</span></span></div></div></div></div>');
//             if(typeof WSAIO !== "undefined" && typeof WSAIO.productDiscount === "function"){
//                 setTimeout(function(){
//                   WSAIO.preCheckout();
//                   WSAIO.checkoutEventListner();
//                 },1000)
//               }
        });
      
      
//       if(typeof WSAIO !== "undefined" && typeof WSAIO.productDiscount === "function"){
//         setTimeout(function(){
//           console.log('cartttttttt')
//           WSAIO.preCheckout();
//           WSAIO.checkoutEventListner();
//         },1000)
//        // WSAIO.cartQuantityController();
//       }

        //re-trigger the remove functionality.
        removeCartItemTrigger();
        cartItemQuantityVariant();

    }
});
}

//remove product by setting quantity to zero via the data attribute.
function removeItemFromCart(variant_id) {
    //ajax get request to cart.js
    $.ajax({
        type: 'POST',
        url: config.shopifyAjaxChangeURL,
        data: 'quantity=0&id=' + variant_id,
        dataType: 'json',
        success: function (data) {

            //console.log('Remove Item Triggered');
            
            //Update the cart to reflect new contents.
            updateMiniCartContents();

        },
        error: function (XMLHttpRequest) {
            var response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;
//             console.log(response);

        }
    });
}


//BG: Function will trigger on the cart page if user changes variant
function addItem(variant_id,quantity,old_variant_id) {
$.ajax({
    type: 'POST',
    url: config.shopifyAjaxAddURL,
    data: 'quantity='+quantity+'&id=' + variant_id,
    dataType: 'json',
    success: function (data) {
        ajaxFeedbackCart('success','Updated size','.product-title[data-variant-id='+old_variant_id+'] .cart-product-variant-select');
    },
    error: function (XMLHttpRequest) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
    }
});
}

//BG: function can be triggered by Quantity update, or variant update.
function quantityItemChange(variant_id,value,addProduct,new_variant_id,quantity) {
//convert string to int
var variant_id = parseInt(variant_id);

//ajax get request to cart.js
$.ajax({
    type: 'POST',
    url: config.shopifyAjaxChangeURL,
    data: 'quantity='+value+'&id=' + variant_id,
    dataType: 'json',
    success: function (data) {
        if (addProduct == 'add') {
            addItem(new_variant_id,quantity,variant_id);
        } else {
            $.each(data.items, function(index,item) {
                if (variant_id === item.variant_id) {
                    if (item.quantity == value) {
                        ajaxFeedbackCart('success','Quantity updated','.basket-item[data-variant-id='+variant_id+'] .product-quantity-select');

                    //BG: if the amount has changed, but not to the value the user wanted.
                    } else if (item.quantity < value) {
                        ajaxFeedbackCart('warning','Quantity Updated to '+item.quantity+'. This is the last remaining amount.','.basket-item[data-variant-id='+variant_id+'] .product-quantity-select');
                    }
                    return false
                }
            });
        }

        //Update Total Price
        var cartTotalCost = slate.Currency.formatMoney(data.total_price , theme.moneyFormat);
        $('#basket-total').html(cartTotalCost);
    },
    error: function (XMLHttpRequest) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
    }
});
}





//Define the remove cart item selector, use the .off & .on feature to ensure it works correctly after new contents added to mini cart.
function removeCartItemTrigger() {
    //Remove Item from Cart
    $(config.cartRemoveSelector + ' span').off().on("click", function () {
        var varientID = $(this).attr('data-variant-id');

        $(this).parents('.cart-item').slideUp();
        
        //Pass over to removeItemFromCart Function.
        removeItemFromCart(varientID);

    });
}

function addToCart(form) {
    $('.ajaxfeedback').remove();
    //e.preventDefault();
    var $addToCartForm = form;
    var $addToCartBtn = $addToCartForm.find(config.addToCartBtnSelector+':first-of-type');

    //Adding button stage
    updateBtnText($addToCartBtn, config.addingToCartBtnText, config.loadingIcon);
    $addToCartBtn.addClass('btn-adding').prop('disabled', true);

    // Add to cart.
    $.ajax({
        url: config.shopifyAjaxAddURL,
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function (itemData) {

            //Added button stage
            updateBtnText($addToCartBtn, config.addedToCartBtnText, config.successIcon);
            $addToCartBtn.removeClass('btn-adding').addClass('btn-added');

            //Once added, reset button back to add.
            window.setTimeout(function () {
                $addToCartBtn.prop('disabled', false).removeClass('btn-added');
                updateBtnText($addToCartBtn, config.addToCartBtnText);
            }, config.returnBtnToNormal);

            setTimeout(function(){

                updateMiniCartContents();
            },500)
        
            window.setTimeout(function () {
                $('.header-basket .cart-icon').addClass('swing animated');
                $('.header-basket').addClass('hover');
            }, 1000);

            window.setTimeout(function () {
                $('.header-basket').removeClass('hover');
                $('.header-basket .cart-icon').removeClass('swing animated');
            }, 4000);
            
        },
        error: function (XMLHttpRequest) {
            var response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;
            if (response.slice(0, 4) === 'All ') {
                ajaxFeedback('error', response.replace('All 1 ', 'All '), $addToCartForm);
                $addToCartBtn.prop('disabled', false);
                updateBtnText($addToCartBtn, config.soldOutBtnText);
                $addToCartBtn.prop('disabled', true).removeClass('btn-adding').removeClass('btn-added');
            } else {
                ajaxFeedback('error', '<i class="fa fa-warning"></i> ' + response, $addToCartForm);
                $addToCartBtn.prop('disabled', false).removeClass('disabled');
                updateBtnText($addToCartBtn, config.addToCartBtnText);
            }

        }

    });
    return false;
}


$(document).ready(function() {

removeCartItemTrigger();
    cartItemQuantityVariant();
$(config.addToCartFormSelector).submit(function (e) {
    e.preventDefault();
    addToCart($(this));
});
});

function quickviewVariant() {
    var variants = $('.product-quickview-frame .swatch-elements'),
        variantInput = $('.product-quickview-frame .product-variant-id');

    $(variants).click(function(){
//       console.log("SSS");
        var variantID = $(this).attr('data-variant-id');
        $(variants).removeClass('active');
        $(this).addClass('active');

        $(variantInput).attr('value',variantID);
//       console.log('variantID',variantID)
      window.selected_variant_id =variantID;
//       setTimeout(function(){
//         WSAIO.selected_variant.id=variantID;
//         $('.waio__single-qc').remove();
//         WSAIO.qtyController({
//           addToCart_selector: '.btn-add-to-cart',
//           functionality: 'variant_level',
//           removeableSelector_qty: '.product-quantity__flex-items',
//           removeableSelector_variants:'.swatch-element'
//         });
//         if($(".product-quickview-frame.active .waio__single-qc").length > 0){
//           $('.cart-item-main, .product__quantity__container').css('display','block');
//         }
//       },500);
//       setTimeout(function(){console.log("WWWW1");
//                             var _indx = current_product.variants.findIndex(function(x){return x.id == variantID}) 
//                             if(_indx > -1){
//                               var _price = current_product.variants[_indx].price;
//                               var _sku = current_product.variants[_indx].sku;
//                               var _compare = current_product.variants[_indx].compare_at_price;
//                             }
//                             WSAIO.variantChange(current_product.variants[_indx],'',current_product)
//                             WSAIO.productDiscount({
//                               template:'product',
//                               product_id: current_product.id,
//                               product_handle: current_product.handle,
//                               variant_id:variantID,
//                               variant_sku: _sku,
//                               variant_price: _price,
//                               variant_compare_at_price: _compare
//                             });WSAIO.variantChange(current_product.variants[_indx],'',current_product)
//                            },1000);
    });
  

}


function productSelectQuantity() {

    var product = $('.product__quantity__container');
    
    var quantitySelect = product.find('.product-quantity'),
      plusQuantity = product.find('[data-quantity="plus"]'),
      quantityInput = product.find('input[name="quantity"]'),
      maxQuantity = quantitySelect.attr('data-max-quantity'),
      minusQuantity = product.find('[data-quantity="minus"]');
    
      $(plusQuantity).click(function(e){
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = product.attr('data-field');
        // Get its current value
        var currentVal = parseInt($(quantityInput).val());
        // If is not undefined
        if (!isNaN(currentVal)) {
          // Increment
          
          //MJ: Only increases quantity if there is the available stock
      
            $(quantityInput).val(currentVal + 1);
            var inputAmount = $(quantityInput).val();
            $(".product-quantity_new .product-quantity").attr('value', inputAmount);
          
        } 
      });
      // This button will decrement the value till 0
      $(minusQuantity).click(function(e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = product.attr('data-field');
        // Get its current value
        var currentVal = parseInt($(quantityInput).val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 1) {
          // Decrement one
          $(quantityInput).val(currentVal - 1);
          var inputAmount = $(quantityInput).val();
          $(".product-quantity").attr('value', inputAmount);
          
        } else {
          $(quantityInput).val(0);
          var inputAmount = $(quantityInput).val();
        }
      });
    }

function quickviewSlick() {
    $('.product-quickview-frame .product-detail-images').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots:false,
        prevArrow: slickPrevArrow,
        nextArrow: slickNextArrow,
        arrows: false,
        fade: true,
    });
}

function quickviewthumbnailSlick() {
    $('.product-quickview-frame .product-detail-thumbnail-images').slick({
        slidesToShow: 3,
       slidesToScroll: 1,
       vertical: true,
        prevArrow: slickPrevArrow,
       nextArrow: slickNextArrow,
       asNavFor: '.product-detail-images',
       focusOnSelect: true,
       responsive: [
           {
               breakpoint: 992,
               settings: {
                   slidesToShow: 3,
                   vertical: false
               }
           }
       ]
   });
}

function quickviewAddToBasket() {
    $('.product-quickview-frame .btn-add-to-cart').click(function(){
        
        $('.product-quickview-frame form').submit(function (e) {
            e.preventDefault();
            addToCart($(this));
        });

        setTimeout(function() {
            $('.product-quickview-frame').removeClass('active');
            $('.product-quickview-overlay').removeClass('active');
            $('html,body').removeClass('quickview-open');
        }, 2500);
    });
    
}

function quickView() {
    var quickViewBtn = $('.product-quickview .btn'),
        quickViewFrame = $('.product-quickview-frame'),
        quickViewOverlay = $('.product-quickview-overlay'),
        quickViewClose = $('.product-quickview-frame .frame-close'),
        quickViewProduct = $('.product-quickview-frame .product-frame');

    $(quickViewBtn).on( "click", function() {
        var productURL = $(this).attr('data-product-url'),
            productAvailability = $(this).attr('data-product-availability');
            productCallToOrder = $(this).attr('data-call-to-order');
//             console.log(productAvailability);


        quickViewFrame.addClass('active');
        quickViewOverlay.addClass('active');
        $('html,body').addClass('quickview-open');
      
     
            

        $.ajax({
            type: 'GET',
            url: productURL + '.json',
            dataType: 'json',
            success: function (data) {


           

                //if compare price (sale price) is available
                var productComparePrice = '';
                if (data.product.variants[0].compare_at_price > data.product.variants[0].price ) {
                    productComparePrice = '<span class="quick2"><span class="product-price-original original-price"><span class="money"> ' + data.product.variants[0].compare_at_price + '</span></span></span>';
                }

    
                
                var productStock = '';
                $.each(data.product.options, function (i, option) {
                    
                    //get product variants
                    var productVariantsStock = ''
                    //loop through each variant
                    $.each(option.values, function(i,variant) {

                        var firstItem = '';
                        if (i == 0) {
                            firstItem = 'active';
                        }

                        productVariantsStock += ''+ data.product.variants[i].inventory_quantity+'';
                    });

                    productStock += '<span>' +
                                            productVariantsStock +    
                                      '</span>'
                });



                //get product variants
                // var productVariants = '';
                // console.log(data.product.options.values);
                // console.log('yup');
                // $.each(data.product.options.values, function (i, variant) {
                //     console.log('test' +vairant);
                // });

                //get product options (variant names)
                var productOptions = '';
                $.each(data.product.options, function (i, option) {
                    
                    //get product variants
                    var productVariants = ''
                    //loop through each variant
                    $.each(option.values, function(i,variant) {

                        var firstItem = '';
                        if (i == 0) {
                            firstItem = 'active';
                        }

                        productVariants += '<div data-value="'+ data.product.variants[i].title+'" data-price="'+data.product.variants[i].price+'" data-variant-id="'+data.product.variants[i].id+'" class="product-quick-view swatch-elements btn '+firstItem+' '+ data.product.variants[i].title+'">'+data.product.variants[i].title+'</div>';
                    });

                    productOptions += '<div class="swatch swatch-'+option.name.toLowerCase()+'">' +
                                        productVariants +    
                                      '</div>'
                });

            
                //get images for products
                var quickviewImages = '';
                $.each(data.product.images, function (i, image) {
                    quickviewImages += '<div class="product-image"><img src="'+ image.src +'" class="img-fluid" alt="'+ data.product.title +'"></div>';
                });

                //get images for products
                var quickviewthumbnailImages = '';
                $.each(data.product.images, function (i, image) {
                    quickviewthumbnailImages += '<div class="product-image"><img src="'+ image.src +'" class="img-fluid" alt="'+ data.product.title +'"></div>';
                });
                var variantStock = data.product.variants[0].inventory_quantity;
//                 console.log(productStock)
                // var variantStock = data.product.available;
                //if product is available, show the available button, if product is sold out, show the sold out option.
                var isCrembel = false;

if (data.product.tags) {

    var tags = data.product.tags;

    if (typeof tags === 'string') {
        tags = tags.split(',');
    }

    for (var i = 0; i < tags.length; i++) {
        if ((tags[i] + '').trim().toLowerCase() === 'preorder') {
            isCrembel = true;
            break;
        }
    }
}

var extraClass = isCrembel ? 'btn-crembel' : '';
var notifyText = isCrembel ? 'Pre-order' : 'Notify me';
                var addToCartButton = '';
                if (productAvailability === "true") {
                    addToCartButton = '<button type="submit" name="add" data-add-to-cart="" class="btn-add-to-cart btn btn-primary mt-3 variant-available"><span data-add-to-cart-text="">Add to basket</span></button>';
                } else if (productCallToOrder === "active") {
                    addToCartButton = '<a href="/products/'+ data.product.handle+'" class="btn-add-to-cart btn btn-primary btn-margin-bottom variant-not-available btn-sold-out"><span data-add-to-cart-text="">Call to order</span></button>';
                } else {
                    addToCartButton = '<a href="/products/'+ data.product.handle+'" class="btn-add-to-cart btn btn-primary btn-margin-bottom variant-not-available btn-sold-out ' + extraClass + '"><span data-add-to-cart-text="">' + notifyText + '</span></button>';
                }

                 

              	var temp = '';
                if(data.product.tags.length > 0)
                {
//                   console.log(data.product.tags.length);
                  var valData = data.product.tags;

                  var valNew = valData.split(', ');

                  var temp = '<ul class="product-allergies">';
                  for (var i = 0; i < valNew.length; i++) {
//                     console.log("Test:"+valNew[i]);
                    if(valNew[i] == 'Free from_Nuts'){
                    	temp = temp + '<li class="nf">NF<span>Nut Free</span></li>';
                    }
                    
                    if(valNew[i] == 'Free from_Gluten'){
                    	temp = temp + '<li class="gf">GF<span>Gluten free</span></li>';
                    }
                    
                    if(valNew[i] == 'Free from_Peanuts'){
                    	temp = temp + '<li class="pf">PF<span>Peanut free</span></li>';
                    }
                    
                    if(valNew[i] == 'Free from_Dairy'){
                    	temp = temp + '<li class="df">DF<span>Dairy free</span></li>';
                    }
                    
                    if(valNew[i] == 'Free from_Palm'){
                    	temp = temp + '<li class="po">PF<span>Palm free</span></li>';
                    }
                    
                    if(valNew[i] == 'Suitable for_Vegetarian'){
                    	temp = temp + '<li class="vg">VG<span>Vegetarian</span></li>';
                    }
                    
                    if(valNew[i] == 'Suitable for_Vegan'){
                    	temp = temp + '<li class="v">V<span>Vegan</span></li>';
                    }
                    
                    if(valNew[i] == 'Suitable for_Halal'){
                    	temp = temp + '<li class="h">H<span>Halal</span></li>';
                    }
                    
                    if(valNew[i] == 'Suitable for_Kosher'){
                    	temp = temp + '<li class="k">K<span>Kosher</span></li>';
                    }
                    
                    
                  }
                  temp = temp + '</ul>';
                }
                //Build Markup output
var quickviewHTML = '<div class="container product-detail-container quickview-product-details">' +
                    '<div class="row align-items-center">' +
                    '<div class="col-12 col-lg-6 mb-3 mb-md-0">' +
                    '<div class="row">' +
                        '<div class="product-detail-thumbnail-images col-lg-2">' +
                        quickviewthumbnailImages + 
                        '</div>' +  
                        '<div class="product-detail-images col-lg-10">' +
                        quickviewImages + 
                        '</div>' +  

                        
                        '</div><!-- Col - Image -->' +

                    '</div><!-- Col - Image -->' +

                    '<div class="col-12 col-lg-6 padding-bottom">' +
                        '<h1 class="product-title"><a href="/products/'+ data.product.handle+'">'+ data.product.title +'</a></h1>' + 
                        '<p class="product-sku product-no-sku">SKU : <span class="variant-sku">'+ data.product.variants[0].sku+'</span></p>'+temp+

                        '<div class="row">' +
                        '<div class="col-12">' + 
                            
                            '<form method="post" action="/cart/add">' +
                            productOptions +
                            
            
                            '<div class="swatch-header">Quantity</div>'+
                                '<input type="hidden" name="id" class="product-variant-id" value="'+ data.product.variants[0].inventory_quantity + '" />' +    


                            '<div class="product__quantity__container product-quantity-container" data-variant-id="'+ data.product.variants[0].id + '">'+
                            '<div class="product-quantity__flex-items">'+
                
                                '<div class="product-quantity" data-max-quantity="200" data-variant-id="'+ data.product.variants[0].id + '">'+
                                '<span class="minus" data-quantity="minus" data-field="quantity"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"></path></svg></span>'+
                                '<input type="number" id="Quantity" class="product-quantity" name="quantity" value="1" min="1" max="200"/>'+
                                '<span class="plus" data-quantity="plus" data-field="quantity"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"></path></svg></span>'+
                                '</div>'+
    

    
                            '</div>'+
                                '<span class="quick1"><span class="product-detail-price">' +
                                    '<span class="money main-price observe wsaio-pid-'+data.product.id+'" data-product-price>£'+ data.product.variants[0].price + '</span>' +
                                '</span></span>' +
                            '</div>'+

                            '<input type="hidden" name="id" class="product-variant-id" value="'+ data.product.variants[0].id + '" />' +    
                            addToCartButton +    
                            '</form>' +
                        '</div><!-- col -->' +    
                        '</div><!-- row -->' +
                    '</div><!-- Col - Details -->' +

                    '</div><!-- row -->' +
                      '</div><!-- container -->';
//                             setTimeout(function(){console.log(data.product.handle);
//                                                   $.getJSON("/products/"+data.product.handle+".js",function(e){
//                                                     window.current_product=e;
//                                                   })
//                                                   setTimeout(function(){
//                                                     WSAIO.selected_variant.id=data.product.variants[0].id;
//                                                     $('.waio__single-qc').remove();
//                                                     WSAIO.qtyController({
//                                                       addToCart_selector: '.btn-add-to-cart',
//                                                       functionality: 'variant_level',
//                                                       removeableSelector_qty: '.product-quantity__flex-items',
//                                                       removeableSelector_variants:'.swatch-element'
//                                                     });
//                                                     if($(".product-quickview-frame.active .waio__single-qc").length > 0){
//                                                       $('.cart-item-main, .product__quantity__container').css('display','block');
//                                                     }
//                                                   },500);
                                                  
//                                                  },2000);
              
              
              
              
                              
//                               setTimeout(function(){console.log("WWWWW");
//                                 WSAIO.productDiscount({
//                                   template:'product',
//                                   product_id: data.product.id,
//                                   product_handle: data.product.handle,
//                                   variant_id: data.product.variants[0].id,
//                                   variant_sku: data.product.variants[0].sku,
//                                   variant_price: data.product.variants[0].price,
//                                   variant_compare_at_price: data.product.variants[0].compare_at_price
//                                 });
//                               },4000);
                    quickViewProduct.html(quickviewHTML);
                    quickviewSlick();
                    quickviewthumbnailSlick();
                    productSelectQuantity();
                    quickviewVariant();
                    quickviewAddToBasket();
            }
        });

    });

    $(quickViewClose).click(function(){
        quickViewFrame.removeClass('active');
        quickViewOverlay.removeClass('active');
        quickViewProduct.html('');
        $('html,body').removeClass('quickview-open');
    });
}

quickView();
//LM Called here initally then also called within PF&S file as well as for Recently Viewed and Related Products.
addProductCompare();
//BG: Init slickSlider for Recently Viewed and Related Products.
function recentSlickSlider(target) {
    var categoryPrevArrow = "<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg width='50px' height='100px' viewBox='0 0 50 100' version='1.1'><g id='carousel_indicator_left' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><g id='Group'><path d='M50,100 C50,100 50,0 50,0 C22.3857625,0 0,22.3857625 0,50 C0,77.6142375 22.3857625,100 50,100 Z' id='Oval' fill='#C8A07D' transform='translate(25.000000, 50.000000) scale(-1, 1) translate(-25.000000, -50.000000) '></path><polyline id='Path-3' stroke='#FFFFFF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' transform='translate(16.666667, 50.000000) scale(-1, 1) rotate(-90.000000) translate(-16.666667, -50.000000) ' points='8.33333333 45.8333333 16.6666667 54.1666667 25 45.8333333'></polyline></g></g></svg></button>",
    categoryNextArrow = "<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg width='50px' height='100px' viewBox='0 0 50 100' version='1.1'><g id='carousel_indicator_right' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><g id='Carousel-left' transform='translate(25.000000, 50.000000) scale(-1, 1) translate(-25.000000, -50.000000) '><path d='M50,100 C50,100 50,0 50,0 C22.3857625,0 0,22.3857625 0,50 C0,77.6142375 22.3857625,100 50,100 Z' id='Oval' fill='#C8A07D' transform='translate(25.000000, 50.000000) scale(-1, 1) translate(-25.000000, -50.000000) '></path><polyline id='Path-3' stroke='#FFFFFF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' transform='translate(16.666667, 50.000000) scale(-1, 1) rotate(-90.000000) translate(-16.666667, -50.000000) ' points='8.33333333 45.8333333 16.6666667 54.1666667 25 45.8333333'></polyline></g></g></svg></button>";
  
    $(target).slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows:true,
        dots: false,
        prevArrow: categoryPrevArrow,
        nextArrow: categoryNextArrow,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
            },
            {
                breakpoint: 768,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
            },
            {
                breakpoint: 480,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots:false
            }
            }
        ]
    });
}

//BG: Grab the recently viewed products array, and loop through the products and output them.
function retrieveRecentlyViewedProducts(array,outputLocation,maxProducts) {

    //if the array is greater than max allowed products, delete the last product from the array.
    if (array.length > maxProducts) {
        array.shift();
    }

    //if there are products to display, remove the hidden class.
    if (array.length > 0) {
        $(outputLocation).removeClass('d-none');
    }
    
    // loop for the array, and output the products.
    $.each(array,function(i, product) {
        //ensure the product isn't undefined.
        if (product != "undefined.js" && product != ".js") {
            //make a json request based on the product handle.
            var ajax = $.getJSON('/products/' + product, function(data) {
                //pass the data over to the below function
                outputProduct(data,outputLocation);
            }).fail(function() { 
                //BG: This should rarely happen, but if the product is no longer available, we get a json error, so want to remove the product from the array. 
                //console.log('product not found, but it will be removed from array on next page load')
                var arrayFix = array.indexOf(product);
                if (arrayFix !== -1) {
                     array.splice(arrayFix,1);
                }
                //BG: Update localStorage
                localStorage.setItem("recentProducts", JSON.stringify(arrayFix));
            });
        }

        //Check to see if it's the last item in the Array, if it is...
        var increment = i + 1;

        if (array.length == increment) {
            persistentCheck('.featured-products.product-recently-viewed .featured-product',5,recentSlickSlider,'.featured-products.product-recently-viewed .featured-products-slick',5000);
        }
    });
}

//BG: Add current product to the recently viewed array
function addNewProduct(array,productHandle,maxProducts) {

  //BG: if array is greater than the maxProducts, then delete the first item in the array
  if (array.length > maxProducts) {
    array.shift();
  }

  //BG: only add the product to the array, if it doesn't already exist
  if(array.indexOf(productHandle) == -1 && productHandle != "undefined.js") {
      array.push(productHandle);
  }
  //BG: Update localStorage
  localStorage.setItem("recentProducts", JSON.stringify(array));

}

//BG: Using localStorage, we create an array based on the products the user has been viewing. When they visit a product page, it stores the product handle. 
function recentlyViewedProducts() {
    //Retrieve localstorage for recentproducts(if it exists)
    var savedRecentProducts = JSON.parse(localStorage.getItem("recentProducts")),
        outputLocation = ".product-recently-viewed",
        newProduct = $(outputLocation).attr('data-product-handle');
        newProduct = newProduct + ".js",
        maxProducts = 7;

    //if localstorage exists, retrieve the list and output it
    if (savedRecentProducts) {
            retrieveRecentlyViewedProducts(savedRecentProducts,outputLocation,maxProducts);

            addNewProduct(savedRecentProducts,newProduct,maxProducts);
    } else {
        //First time user has visited a product page, so let's create the new local storage.
//         console.log('doesn\'t exist, let\'s make a new array');
        var recentProducts = [];
        addNewProduct(recentProducts,newProduct,maxProducts);
    }
}

setTimeout(function(){


    recentlyViewedProducts();
},2000)


//LM: Add the Product to the Comparison Locale Storage Array
function addNewProductComparison(array, productHandle, storageType, button) {
    array.push(productHandle);
    localStorage.setItem(storageType, JSON.stringify(array));
    var newProductComparison = JSON.parse(localStorage.getItem(storageType));
    var length = Object.keys(newProductComparison).length;
    //LM: Update Product Detail button text
    $(button).addClass('active');
    $('.product-compare[data-product-handle="'+ productHandle +'"]').addClass('active');
    //LM: Updated Count of the array
    $('.product-compare-container .count').text(length);
    $('.btn-product-compare-modal .count').text(length);
    //LM: If one or more products is in array then show the compare module in bottom left hand corner of screen.
    if(length > 0 ) {
        $('.product-compare-container').addClass('active');
    }
}
//LM: Loop through the array in local storage and output results.
// This is used for the small comparison table.
function renderSmallCompare(array, outputLocation) {
    if (array.length > 0) {
        // loop for the array, and output the products. Had to  use 'async: false' so that they loop in order of the array.
        // This uses the product.listing-small.liquid template file.
        $.each(array,function(i, product) {
            $.ajax({
                type: 'GET',
                async: false,
                url: '/products/' + product +'/?view=listing-small',
                success: function (data) {
                    $(outputLocation).append(data);
//                     console.log(data);
                },
                complete: function() {
                    removeProduct();
                }
            });
        });
    }
}
//LM: Loop through the array in local storage and output results.
// This is used for the large comparison table.
function renderCompare(array, outputLocation) {
    if (array.length > 0) {
        // loop for the array, and output the products. Had to  use 'async: false' so that they loop in order of the array.
        // This uses the product.compare.liquid template file.
        $.each(array,function(i, product) {
            $.ajax({
                type: 'GET',
                async: false,
                url: '/products/' + product +'/?view=compare',
                success: function (data) {
                    $(outputLocation).append(data);
                },
                complete: function() {
                    removeProduct();
                }
            });
        });
    }
}
//LM When 'remove' icon is clicked.
function removeProduct() {
    $('.comparison-table .column').each(function(){
        var column = $(this),
            close = $(column).find('.close'),
            columnID = $(column).attr('data-handle');
        $(close).off().on('click', function(){
            var comparisonTableLocal = $('.comparison-table').attr('data-local-storage'),
            tableComparisonCheck = JSON.parse(localStorage.getItem(comparisonTableLocal));
            // Hide column
            $(column).css('display', 'none');
            $('.column[data-handle="' + columnID + '"]').css('display', 'none');
            // Remove product from array in local storage
            var index = tableComparisonCheck.indexOf(columnID);
            if (index > -1) {
                tableComparisonCheck.splice(index, 1);
                localStorage.setItem(comparisonTableLocal, JSON.stringify(tableComparisonCheck));
            }
            // Get the new Local Storage array and its length.
            var NewComparison = JSON.parse(localStorage.getItem('all_compare'));
            var length = Object.keys(NewComparison).length;
            // Output relevant length and change product compare text.
            $('.product-compare[data-product-handle="'+ columnID +'"]').removeClass('active');
            $('.product-compare-container .count').text(length);
            $('.btn-product-compare-modal .count').text(length);
            // If array is empty then hide compare module all together.
            if(length == 0) {
                localStorage.removeItem('all_compare');
                $('.product-compare-container').removeClass('active');
                $('.btn-product-compare').removeClass('active');
                $('.product-compare-pop-out').removeClass('active');
                $('.comparison-table-container').removeClass('active');
            }
        });
    });
}
function addProductCompare() {
    // check if array exists
    var savedProductComparison = JSON.parse(localStorage.getItem('all_compare'));
    // On 'Add to Compare' button click
    $('.product-compare').each(function(){
        var button = $(this),
        productHandle = $(this).attr('data-product-handle')
        productType = $(this).attr('data-product-type');
        $(this).off().on('click', function(){
            var UpdatedProductComparison = JSON.parse(localStorage.getItem('all_compare'));
            // If there is a array in local storage then try to add.
            if (UpdatedProductComparison) {
                var length = Object.keys(UpdatedProductComparison).length;
                // If relevant local storage array has 4 or more products then show warning. If not then add product to the array.
                if( length == 4 ) {
                    ajaxFeedbackCart('warning','Maxiumum of 4 products for comparison.', button);
                } else if (jQuery.inArray(productHandle, UpdatedProductComparison) == -1) {
                    // Add the product to array.
                    addNewProductComparison(UpdatedProductComparison, productHandle, 'all_compare', button);
                    $('.product-compare-container .comparison-table').empty();
                    var ProductComparison = JSON.parse(localStorage.getItem('all_compare'));
                    if($('.product-compare-container .comparison-table').is(':empty')) {
                        renderSmallCompare(ProductComparison, '.product-compare-container .comparison-table');
                    }
                }
            } else {
                // Relevant Local Storage is not available therefore lets add the product to brand new array.
                var productsComparison = [];
                addNewProductComparison(productsComparison, productHandle, 'all_compare', button);
                $('.product-compare-container .comparison-table').empty();
                var ProductComparison = JSON.parse(localStorage.getItem('all_compare'));
                if($('.product-compare-container .comparison-table').is(':empty')) {
                    renderSmallCompare(ProductComparison, '.product-compare-container .comparison-table');
                }
            }
        });
    });
    // If Local Storage Array is present.
    if (savedProductComparison) {
        $('.product-compare').each(function(){
            var button = $(this),
                productHandle = $(this).attr('data-product-handle');
            // If product handle is already in array then change wording on comparison button.
            if (jQuery.inArray(productHandle, savedProductComparison) !== -1) {
                $(button).addClass('active');
            }
        });
        var length = Object.keys(savedProductComparison).length;
        $('.product-compare-container').addClass('active');
        $('.product-compare-container .count').text(length);
        $('.btn-product-compare-modal .count').text(length);
    }
    // Intial compare button that is sticky in bottom left hand column. When clicked render the compare module and fetch product data.
    $('.btn-product-compare').off().on('click', function(){
        if($(this).hasClass('active')){
            $(this).removeClass('active');
            $('.product-compare-pop-out').removeClass('active');
            $('.comparison-table-container').removeClass('active');
        } else {
            $(this).addClass('active');
            $('.product-compare-pop-out').addClass('active');
            $('.comparison-table-container').addClass('active');
            var ProductComparison = JSON.parse(localStorage.getItem('all_compare'));
//             console.log(ProductComparison);
            if($('.product-compare-container .comparison-table').is(':empty')) {
                renderSmallCompare(ProductComparison, '.product-compare-container .comparison-table');
            }
        }
    });
    // Remove all Button - close everythign and clear the local storage array.
    $('.remove-all-comparison').off().on('click', function(){
        localStorage.removeItem('all_compare');
        $('.product-compare-container').removeClass('active');
        $('.btn-product-compare').removeClass('active');
        $('.product-compare-pop-out').removeClass('active');
        $('.comparison-table-container').removeClass('active');
        $('.product-compare').each(function(){
            $(this).removeClass('active');
        });
    });
    // Close the comparison module button.
    $('.comparison-close').off().on('click', function(){
        $('.product-compare-container .comparison-table').empty();
        $('.btn-product-compare').removeClass('active');
        $('.product-compare-pop-out').removeClass('active');
        $('.comparison-table-container').removeClass('active');
    });
    // Render Large Comparison table overlay. Fetch full product data for table.
    $('.btn-product-compare-modal').off().on('click', function(){
        $('.product-overlay-table').addClass('active');
        $('html').addClass('no-scroll');
        $('body').addClass('no-scroll');
        var FullProductComparison = JSON.parse(localStorage.getItem('all_compare'));
        renderCompare(FullProductComparison, '.product-overlay-table .comparison-table');
        if($('.product-overlay-table .comparison-table').hasClass('is-dynamic')) {
            renderDynamicAttributes();
        }
    });
    // Close button for table overlay.
    $('.product-overlay-table .close').off().on('click', function(){
        $('html').removeClass('no-scroll');
        $('body').removeClass('no-scroll');
        $('.product-overlay-table').removeClass('active');
        $('.product-overlay-table .comparison-table .product-column').remove();
    });
}

function renderDynamicAttributes(){
    $('.comparison-table.is-dynamic.auto-comparison').each(function (){
        var attributes = [];
        var titleColumns = $(this).find('div.column.title-column.comparison-auto.comparison-titles');
        var productColumns = $(this).find('div.product-column.comparison-auto.comparison-item.pending-population');
        var titleBarHtml = "";
        productColumns.each(function (productColumnKey, productColumn) {
            var productAttributes = JSON.parse($(productColumn).attr('data-attributes'));
            if(productAttributes == undefined) {
                return;
            }
            Object.keys(productAttributes).forEach(function(attribute){
                if (!attributes.includes(attribute)) {
                    attributes.push(attribute);
                }
            });
        });
        for(var attributeKey in  attributes) {
            var attribute = attributes[attributeKey];
            titleBarHtml += "<div class='field dynamic-title'>" + attribute + "</div>";
        }
        titleColumns.each(function (){
            $(this).find('.field.dynamic-title').remove();
            $(this).find('.field.options-field').before(titleBarHtml);
        });
        productColumns.each(function (){
            var productAttributes = JSON.parse($(this).attr('data-attributes'));
            var productBarHtml = "";
            for(var attributeKey in attributes) {
                var attribute = attributes[attributeKey];
                if(productAttributes == undefined) {
                    productBarHtml += "<div class='field'>N/A</div>";
                } else {
                    if(attribute in productAttributes){
                        productBarHtml += "<div class='field'>" + productAttributes[attribute] + "</div>";
                    } else {
                        productBarHtml += "<div class='field'>N/A</div>";
                    }
                }
            }
            $(this).removeClass('pending-population')
            $($(this).find('.comparison-insertion.values')[0]).replaceWith(function(){
                return $.parseHTML(productBarHtml);
            })
        });
    });
}
//LM Called here initally then also called within PF&S file as well as for Recently Viewed and Related Products.
addProductCompare();

function callToOrder(){
  $('#call_to_order').click(function() {
      var phone = $('.product-add-to-basket').attr('data-phone');
      window.location.href = 'tel:'+ phone +''
//       console.log('tel:'+ phone +'')
  });
}

callToOrder();

$(document).ready(function() {


  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }


});

/* ==========================================================================
#Custom Velstar
========================================================================== */

//product page swatch change
$('.swatch :radio').change(function() {
    var optionIndex = $(this).closest('.swatch').attr('data-option-index');
    var optionValue = $(this).val();
    $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
});

// Sync the Slick product gallery to the selected variant's image
$(document).on('variantImageChange', '[data-section-type="product"]', function(evt) {
  var variant = evt.variant;
  if (!variant || !variant.featured_image) return;

  var imageId = variant.featured_image.id;

  var $mainSlider = $('.product-detail-images');
  var $thumbSlider = $('.product-detail-thumbnails');

  var slideIndex = $mainSlider.find('[data-image-id="' + imageId + '"]').closest('.product-image').index();

  if (slideIndex > -1) {
    if ($mainSlider.hasClass('slick-initialized')) {
      $mainSlider.slick('slickGoTo', slideIndex);
    }
    if ($thumbSlider.hasClass('slick-initialized')) {
      $thumbSlider.slick('slickGoTo', slideIndex);
    }
  }
});

Shopify.Cart.ShippingCalculator.show( {
  submitButton: theme.strings.shippingCalcSubmitButton,
  submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
  customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
  moneyFormat: theme.strings.shippingCalcMoneyFormat
} );

this.reorder = new function(){
  var self = this;

  this.pushQueue = function(i, data, el){
    
    //LOW STOCK -- add as many as possible if stock is below requested ammount
    if(data[i].check_inventory){
      data[i].quantity = Math.min(parseInt(data[i].inventory), parseInt(data[i].quantity));
    }
    
    $.ajax({
      url: '/cart/add.js',
      method: 'POST',
      data: {
        quantity: data[i].quantity,
        id: data[i].id
      },
      complete: function(res){
        if(i >= data.length - 1){
          //products from queue are now added to the cart -> stop loading signal and go to cart
          el.removeClass('loading');
          window.location.href = '/cart';
          return;
        }else{
          // Calls are async as required by Shopify Docs
             self.pushQueue(i+1, data, el);
        }
      }
    });
  }

  this.listen = function(){
    var el = $(this);
    var ids = el.attr('data-variant-ids').split(',');
    var quantities = el.attr('data-variant-quantities').split(',');
    var inventories = el.attr('data-variant-inventories').split(',');
    var inventory_policies = el.attr('data-variant-inventory-policies').split(',');
    var inventory_trackers = el.attr('data-variant-inventory-trackers').split(',');
    ids.splice(-1, 1);
    quantities.splice(-1, 1);
    inventories.splice(-1, 1);
    inventory_policies.splice(-1, 1);
    inventory_trackers.splice(-1, 1);
    
    var data = [];
    for(var i=0; i<ids.length; i++){
      data.push({
        id: ids[i],
        quantity: quantities[i],
        inventory: inventories[i],
        check_inventory: (inventory_policies[i] == "deny" && inventory_trackers[i] != "")
      });
    }
    el.addClass('loading');
    self.pushQueue(0, data, el);
  }
  
  this.init = function(){
    $('.reorder-btn').on('click', self.listen);
  }
}
$(reorder.init);
